class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.item = $(this).closest(".productView");
    this.isFullWidth = this.item.is(".layout-4");

    this.onVariantInit();
    this.addEventListener("change", this.onVariantChange.bind(this));
  }

  onVariantInit() {
    this.updateOptions();
    this.updateOptionVariants();
    this.updateMasterId();
    this.updateMedia(1500);
    // this.updateURL();
    this.renderProductAjaxInfo();
    this.renderProductInfo();
    if (!this.currentVariant) {
      this.updateAttribute(true);
    } else {
      this.updateAttribute(false, !this.currentVariant.available);
    }
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateOptionVariants();

    if (!this.currentVariant) {
      this.updateAttribute(true);
      this.updateStickyAddToCart(true);
    } else {
      this.updateMedia(200);
      this.updateURL();
      this.updateVariantInput();
      this.renderProductAjaxInfo();
      this.renderProductInfo();
      this.updateProductInfo();
      this.updateAttribute(false, !this.currentVariant.available);
      this.updateStickyAddToCart(false, !this.currentVariant.available);
      this.checkQuantityWhenVariantChange();
    }
    var varIdAtc = document.querySelector(".asVarId1").getAttribute("value");
    var varIdDec = document.querySelectorAll(".asVDCommon");
    varIdDec.forEach(function (item) {
      var itemAttr = item.getAttribute("value");
      if (varIdAtc === itemAttr) {
        item.classList.add("active");
      } else {
        item.classList.remove("active");
      }
    });
  }

  updateOptionVariants() {
    const caratInput = document.querySelector('.Diamond_Weight input[type="radio"]:checked');
    const caratFullValue = caratInput ? caratInput.value : '';

    const selectEl = document.querySelector('select[name="variant-options-container"]');
    if (!selectEl || !caratFullValue) return;

    const options = selectEl.querySelectorAll('option');

    const hasColorOption = document.querySelector('.Diamond_Color');
    const hasPurityOption = document.querySelector('.Diamond_Purity');

    let availableColors = new Set();
    let availableClarities = new Set();

    options.forEach(option => {
      if (option.dataset.option1 !== caratFullValue || option.disabled) return;

      if (hasColorOption && option.dataset.option2) {
        availableColors.add(option.dataset.option2);
      }

      if (hasPurityOption && option.dataset.option3) {
        availableClarities.add(option.dataset.option3);
      }
    });

    /* ---------------- COLOR ---------------- */
    if (hasColorOption) {
      document.querySelectorAll('.Diamond_Color input[type="radio"]').forEach(radio => {
        const wrapper = radio.closest('.product-variant-input-radio');
        const label = wrapper?.querySelector('label');

        const isAvailable = availableColors.has(radio.value);

        radio.disabled = !isAvailable;
        wrapper?.classList.toggle('is-disabled', !isAvailable);
        label?.classList.toggle('soldout', !isAvailable);
      });
    }

    /* ---------------- PURITY ---------------- */
    if (hasPurityOption) {
      document.querySelectorAll('.Diamond_Purity input[type="radio"]').forEach(radio => {
        const wrapper = radio.closest('.product-variant-input-radio');
        const label = wrapper?.querySelector('label');

        // IMPORTANT FIX:
        // If Color does not exist, Purity should NOT be restricted
        const isAvailable = hasColorOption
          ? availableClarities.has(radio.value)
          : true;

        radio.disabled = !isAvailable;
        wrapper?.classList.toggle('is-disabled', !isAvailable);
        label?.classList.toggle('soldout', !isAvailable);
      });
    }

    /* ---------------- AUTO SELECT FIRST AVAILABLE ---------------- */
    function checkFirstAvailableRadio(containerSelector) {
      const container = document.querySelector(containerSelector);
      if (!container) return;

      const items = Array.from(
        container.querySelectorAll('.product-variant-input-radio')
      )
        .map(wrapper => {
          const radio = wrapper.querySelector('input[type="radio"]');
          if (!radio || radio.disabled || wrapper.offsetParent === null) return null;

          const rect = wrapper.getBoundingClientRect();
          return { radio, top: rect.top, left: rect.left };
        })
        .filter(Boolean);

      if (items.some(item => item.radio.checked)) return;

      items.sort((a, b) => {
        if (a.top !== b.top) return a.top - b.top;
        return b.left - a.left;
      });

      if (items.length) {
        items[0].radio.checked = true;
        items[0].radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    checkFirstAvailableRadio('.Diamond_Color');
    checkFirstAvailableRadio('.Diamond_Purity');
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  decodeOptions() {
    this.options = this.options.map((option) => {
      const parsedOption = this.decodeOption(option);
      return parsedOption;
    });
  }

  decodeOption(option) {
    if (option) {
      return option
        .split("Special_Double_Quote")
        .join('"')
        .split("Special_Slash")
        .join("/");
    } else {
      return null;
    }
  }

  encodeOption(option) {
    if (option) {
      return option
        .split('"')
        .join("Special_Double_Quote")
        .split("/")
        .join("Special_Slash");
    } else {
      return null;
    }
  }

  updateMasterId() {
    this.decodeOptions();
    console.log(this.getVariantData())
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia(time) {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;

    const newMedia = document.querySelectorAll(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    window.setTimeout(() => {
      $(newMedia).trigger("click");
    }, time);

    if (!this.isFullWidth || window.innerWidth < 768) return;

    const mediaToReplace = document.querySelector(
      '.productView-image[data-index="1"]'
    );
    const imageToReplace = mediaToReplace.querySelector("img");

    if (!this.currentVariant) return;

    const image = this.currentVariant?.featured_image;

    if (image == null) return;

    imageToReplace.setAttribute("src", image.src);
    imageToReplace.setAttribute("srcset", image.src);
    imageToReplace.setAttribute("alt", image.alt);

    if (mediaToReplace.getBoundingClientRect().top < window.scrollY) {
      this.scrollToBlock(mediaToReplace);
    }
  }

  scrollToBlock(block) {
    const headerHeight = document
      .querySelectorAll(".section-header-navigation")[0]
      ?.getBoundingClientRect().height;
    const announcementBarHeight = document
      .querySelectorAll(".announcement-bar")[0]
      ?.getBoundingClientRect().height;
    const positionTop =
      block.getBoundingClientRect().top - headerHeight - announcementBarHeight;

    window.scrollTo({
      top: positionTop,
      behavior: "smooth",
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.product}, #product-form-installment-${this.dataset.product}`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductAjaxInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `product-price-${this.dataset.product}`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        const property = `product-property-${this.dataset.product}`;
        const destinationProperty = document.getElementById(property);
        const sourceProperty = html.getElementById(property);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }

        if (this.checkNeedToConvertCurrency()) {
          let currencyCode = document
            .getElementById("currencies")
            ?.querySelector(".active")
            ?.getAttribute("data-currency");

          Currency.convertAll(
            window.shop_currency,
            currencyCode,
            "span.money",
            "money_format"
          );
        }

        if (destinationProperty) {
          if (sourceProperty) {
            destinationProperty.innerHTML = sourceProperty.innerHTML;
            destinationProperty.style.display = "table";
          } else {
            destinationProperty.style.display = "none";
          }
        } else if (sourceProperty) {
          document
            .querySelector(".productView-product")
            .insertBefore(
              sourceProperty,
              document.querySelector(".productView-options")
            );
        }

        document
          .getElementById(`product-price-${this.dataset.product}`)
          ?.classList.remove("visibility-hidden");
        const startUpdatePrice = new Event('updateMainPrice');
        document.dispatchEvent(startUpdatePrice);
      });
  }

  renderProductInfo() {
    var variantList = this.getVariantData().filter((variant) => {
      return variant.available;
    });

    var selectedOption1 = this.currentVariant?.option1,
      selectedOption2 = this.currentVariant?.option2,
      selectedOption3 = this.currentVariant?.option3,
      options = this.item.find(".product-form__input"),
      optionsLength = options.length,
      pvOptionsLength = this.item.find(
        ".productView-details .product-form__input"
      ).length,
      checkStickyVariant = false;

    // let parsedSelectedOption1 = selectedOption1 ? parseDoubleQuote(selectedOption1) : null,
    //     parsedSelectedOption2 = selectedOption2 ? parseDoubleQuote(selectedOption2) : null,
    //     parsedSelectedOption3 = selectedOption3 ? parseDoubleQuote(selectedOption3) : null;

    optionsLength > pvOptionsLength ? (checkStickyVariant = true) : "";

    $.each(options, (index, element) => {
      var position = $(element).data("option-index"),
        type = $(element).data("product-attribute");

      switch (position) {
        case 0:
          $(element).find("[data-header-option]").text(selectedOption1);

          if (type == "set-select") {
            var selectList = $(element).find(".select__select option");

            selectList.each((idx, elt) => {
              if (elt.value == selectedOption1) {
                $(elt).attr("selected", "selected");
              } else {
                $(elt).removeAttr("selected");
              }
            });
          } else {
            $(element).find(".product-form__radio").prop("checked", false);
            $(element)
              .find(
                `.product-form__radio[value="${this.encodeOption(
                  selectedOption1
                )}"]`
              )
              .prop("checked", true);
          }

          var option1List = variantList.filter((variant) => {
            return variant.option1 === selectedOption1;
          });

          if (selectedOption2) {
            var inputList = $(options[1]),
              input = inputList.find(".product-form__radio"),
              selectOption = inputList.find(".select__select option");

            if (checkStickyVariant) {
              var inputListSticky = $(options[1 + pvOptionsLength]),
                inputSticky = inputListSticky.find(".product-form__radio"),
                selectOptionSticky = inputListSticky.find(
                  ".select__select option"
                );
            }

            if (type == "set-rectangle") {
              input.each((idx, elt) => {
                var $input = $(elt),
                  $label = $input.next(),
                  optionValue = this.decodeOption($(elt).val());

                var optionSoldout = option1List.find((variant) => {
                  return variant.option2 == optionValue;
                });

                if (optionSoldout == undefined) {
                  $label.removeClass("available").addClass("soldout");
                  if (checkStickyVariant) {
                    $(inputSticky[idx])
                      .next()
                      .removeClass("available")
                      .addClass("soldout");
                  }
                } else {
                  $label.removeClass("soldout").addClass("available");
                  if (checkStickyVariant) {
                    $(inputSticky[idx])
                      .next()
                      .removeClass("soldout")
                      .addClass("available");
                  }
                }
              });
            } else {
              selectOption.each((idx, elt) => {
                var $option = $(elt),
                  optionValue = this.decodeOption($(elt).val());

                var optionSoldout = option1List.find((variant) => {
                  return variant.option2 == optionValue;
                });

                if (optionSoldout == undefined) {
                  $option.attr("disabled", true);
                  if (checkStickyVariant) {
                    $(selectOptionSticky[idx]).attr("disabled", true);
                  }
                } else {
                  $option.removeAttr("disabled");
                  if (checkStickyVariant) {
                    $(selectOptionSticky[idx]).removeAttr("disabled");
                  }
                }
              });
            }
          }

          if (selectedOption3) {
            var inputList = $(options[2]),
              input = inputList.find(".product-form__radio"),
              selectOption = inputList.find(".select__select option");

            if (checkStickyVariant) {
              var inputListSticky = $(options[2 + pvOptionsLength]),
                inputSticky = inputListSticky.find(".product-form__radio"),
                selectOptionSticky = inputListSticky.find(
                  ".select__select option"
                );
            }

            if (type == "set-rectangle") {
              input.each((idx, elt) => {
                var $input = $(elt),
                  $label = $input.next(),
                  optionValue = this.decodeOption($(elt).val());

                var optionSoldout = option1List.find((variant) => {
                  return variant.option3 == optionValue;
                });

                if (optionSoldout == undefined) {
                  $label.removeClass("available").addClass("soldout");
                  if (checkStickyVariant) {
                    $(inputSticky[idx])
                      .next()
                      .removeClass("available")
                      .addClass("soldout");
                  }
                } else {
                  $label.removeClass("soldout").addClass("available");
                  if (checkStickyVariant) {
                    $(inputSticky[idx])
                      .next()
                      .removeClass("soldout")
                      .addClass("available");
                  }
                }
              });
            } else {
              selectOption.each((idx, elt) => {
                var $option = $(elt),
                  optionValue = this.decodeOption($(elt).val());

                var optionSoldout = option1List.find((variant) => {
                  return variant.option3 == optionValue;
                });

                if (optionSoldout == undefined) {
                  $option.attr("disabled", true);
                  if (checkStickyVariant) {
                    $(selectOptionSticky[idx]).attr("disabled", true);
                  }
                } else {
                  $option.removeAttr("disabled");
                  if (checkStickyVariant) {
                    $(selectOptionSticky[idx]).removeAttr("disabled");
                  }
                }
              });
            }
          }

          break;
        case 1:
          $(element).find("[data-header-option]").text(selectedOption2);

          if (type == "set-select") {
            var selectList = $(element).find(".select__select option");

            selectList.each((idx, elt) => {
              if (elt.value == selectedOption2) {
                $(elt).attr("selected", "selected");
              } else {
                $(elt).removeAttr("selected");
              }
            });
          } else {
            $(element).find(".product-form__radio").prop("checked", false);
            $(element)
              .find(
                `.product-form__radio[value="${this.encodeOption(
                  selectedOption2
                )}"]`
              )
              .prop("checked", true);
          }

          var option2List = variantList.filter((variant) => {
            return variant.option2 === selectedOption2;
          });

          if (selectedOption1) {
            var inputList = $(options[0]),
              input = inputList.find(".product-form__radio"),
              selectOption = inputList.find(".select__select option");

            if (checkStickyVariant) {
              var inputListSticky = $(options[pvOptionsLength]),
                inputSticky = inputListSticky.find(".product-form__radio"),
                selectOptionSticky = inputListSticky.find(
                  ".select__select option"
                );
            }

            if (type == "set-rectangle") {
              input.each((idx, elt) => {
                var $input = $(elt),
                  $label = $input.next(),
                  optionValue = this.decodeOption($(elt).val());

                var optionSoldout = option2List.find((variant) => {
                  return variant.option1 == optionValue;
                });

                if (optionSoldout == undefined) {
                  $label.removeClass("available").addClass("soldout");
                  if (checkStickyVariant) {
                    $(inputSticky[idx])
                      .next()
                      .removeClass("available")
                      .addClass("soldout");
                  }
                } else {
                  $label.removeClass("soldout").addClass("available");
                  if (checkStickyVariant) {
                    $(inputSticky[idx])
                      .next()
                      .removeClass("soldout")
                      .addClass("available");
                  }
                }
              });
            } else {
              selectOption.each((idx, elt) => {
                var $option = $(elt),
                  optionValue = this.decodeOption($(elt).val());

                var optionSoldout = option2List.find((variant) => {
                  return variant.option1 == optionValue;
                });

                if (optionSoldout == undefined) {
                  $option.attr("disabled", true);
                  if (checkStickyVariant) {
                    $(inputSticky[idx]).attr("disabled", true);
                  }
                } else {
                  $option.removeAttr("disabled");
                  if (checkStickyVariant) {
                    $(inputSticky[idx]).removeAttr("disabled");
                  }
                }
              });
            }
          }

          if (selectedOption3) {
            var inputList = $(options[2]),
              input = inputList.find(".product-form__radio"),
              selectOption = inputList.find(".select__select option");

            if (checkStickyVariant) {
              var inputListSticky = $(options[2 + pvOptionsLength]),
                inputSticky = inputListSticky.find(".product-form__radio"),
                selectOptionSticky = inputListSticky.find(
                  ".select__select option"
                );
            }

            if (type == "set-rectangle") {
              input.each((idx, elt) => {
                var $input = $(elt),
                  $label = $input.next(),
                  optionValue = this.decodeOption($(elt).val());

                var optionSoldout = option2List.find((variant) => {
                  return variant.option3 == optionValue;
                });

                if (optionSoldout == undefined) {
                  $label.removeClass("available").addClass("soldout");
                  if (checkStickyVariant) {
                    $(inputSticky[idx])
                      .next()
                      .removeClass("available")
                      .addClass("soldout");
                  }
                } else {
                  $label.removeClass("soldout").addClass("available");
                  if (checkStickyVariant) {
                    $(inputSticky[idx])
                      .next()
                      .removeClass("soldout")
                      .addClass("available");
                  }
                }
              });
            } else {
              selectOption.each((idx, elt) => {
                var $option = $(elt),
                  optionValue = this.decodeOption($(elt).val());

                var optionSoldout = option2List.find((variant) => {
                  return variant.option3 == optionValue;
                });

                if (optionSoldout == undefined) {
                  $option.attr("disabled", true);
                  if (checkStickyVariant) {
                    $(inputSticky[idx]).attr("disabled", true);
                  }
                } else {
                  $option.removeAttr("disabled");
                  if (checkStickyVariant) {
                    $(inputSticky[idx]).removeAttr("disabled");
                  }
                }
              });
            }
          }

          break;
        case 2:
          $(element).find("[data-header-option]").text(selectedOption3);

          if (type == "set-select") {
            var selectList = $(element).find(".select__select option");

            selectList.each((idx, elt) => {
              if (elt.value == selectedOption3) {
                $(elt).attr("selected", "selected");
              } else {
                $(elt).removeAttr("selected");
              }
            });
          } else {
            $(element).find(".product-form__radio").prop("checked", false);
            $(element)
              .find(
                `.product-form__radio[value="${this.encodeOption(
                  selectedOption3
                )}"]`
              )
              .prop("checked", true);
          }

          var option3List = variantList.filter((variant) => {
            return variant.option3 === selectedOption3;
          });

          if (selectedOption1) {
            var inputList = $(options[0]),
              input = inputList.find(".product-form__radio"),
              selectOption = inputList.find(".select__select option");

            if (checkStickyVariant) {
              var inputListSticky = $(options[pvOptionsLength]),
                inputSticky = inputListSticky.find(".product-form__radio"),
                selectOptionSticky = inputListSticky.find(
                  ".select__select option"
                );
            }

            if (type == "set-rectangle") {
              input.each((idx, elt) => {
                var $input = $(elt),
                  $label = $input.next(),
                  optionValue = this.decodeOption($(elt).val());

                var optionSoldout = option3List.find((variant) => {
                  return variant.option1 == optionValue;
                });

                if (optionSoldout == undefined) {
                  $label.removeClass("available").addClass("soldout");
                  if (checkStickyVariant) {
                    $(inputSticky[idx])
                      .next()
                      .removeClass("available")
                      .addClass("soldout");
                  }
                } else {
                  $label.removeClass("soldout").addClass("available");
                  if (checkStickyVariant) {
                    $(inputSticky[idx])
                      .next()
                      .removeClass("soldout")
                      .addClass("available");
                  }
                }
              });
            } else {
              selectOption.each((idx, elt) => {
                var $option = $(elt),
                  optionValue = this.decodeOption($(elt).val());

                var optionSoldout = option3List.find((variant) => {
                  return variant.option1 == optionValue;
                });

                if (optionSoldout == undefined) {
                  $option.attr("disabled", true);
                  if (checkStickyVariant) {
                    $(inputSticky[idx]).attr("disabled", true);
                  }
                } else {
                  $option.removeAttr("disabled");
                  if (checkStickyVariant) {
                    $(inputSticky[idx]).removeAttr("disabled");
                  }
                }
              });
            }
          }

          if (selectedOption2) {
            var inputList = $(options[1]),
              input = inputList.find(".product-form__radio"),
              selectOption = inputList.find(".select__select option");

            if (checkStickyVariant) {
              var inputListSticky = $(options[1 + pvOptionsLength]),
                inputSticky = inputListSticky.find(".product-form__radio"),
                selectOptionSticky = inputListSticky.find(
                  ".select__select option"
                );
            }

            if (type == "set-rectangle") {
              input.each((idx, elt) => {
                var $input = $(elt),
                  $label = $input.next(),
                  optionValue = this.decodeOption($(elt).val());

                var optionSoldout = option3List.find((variant) => {
                  return variant.option2 == optionValue;
                });

                if (optionSoldout == undefined) {
                  $label.removeClass("available").addClass("soldout");
                  if (checkStickyVariant) {
                    $(inputSticky[idx])
                      .next()
                      .removeClass("available")
                      .addClass("soldout");
                  }
                } else {
                  $label.removeClass("soldout").addClass("available");
                  if (checkStickyVariant) {
                    $(inputSticky[idx])
                      .next()
                      .removeClass("soldout")
                      .addClass("available");
                  }
                }
              });
            } else {
              selectOption.each((idx, elt) => {
                var $option = $(elt),
                  optionValue = this.decodeOption($(elt).val());

                var optionSoldout = option3List.find((variant) => {
                  return variant.option2 == optionValue;
                });

                if (optionSoldout == undefined) {
                  $option.attr("disabled", true);
                  if (checkStickyVariant) {
                    $(inputSticky[idx]).attr("disabled", true);
                  }
                } else {
                  $option.removeAttr("disabled");
                  if (checkStickyVariant) {
                    $(inputSticky[idx]).removeAttr("disabled");
                  }
                }
              });
            }
          }

          break;
      }
    });

    if (this.item.find("[data-sku]").length > 0) {
      this.item
        .find("[data-sku] .productView-info-value")
        .text(this.currentVariant.sku);
    }

    var inventory = this.currentVariant?.inventory_management;

    if (inventory != null) {
      var arrayInVarName = `product_inven_array_${this.dataset.product}`,
        inven_array = window[arrayInVarName];

      if (inven_array != undefined) {
        var inven_num = inven_array[this.currentVariant.id],
          inventoryQuantity = parseInt(inven_num);

        this.item
          .find('input[name="quantity"]')
          .attr("data-inventory-quantity", inventoryQuantity);

        if (this.item.find("[data-inventory]").length > 0) {
          if (inventoryQuantity > 0) {
            const showStock = this.item
              .find("[data-inventory]")
              .data("stock-level");
            if (showStock == "show") {
              this.item
                .find("[data-inventory] .productView-info-value")
                .text(inventoryQuantity + " " + window.inventory_text.inStock);
            } else {
              this.item
                .find("[data-inventory] .productView-info-value")
                .text(window.inventory_text.inStock);
            }
          } else {
            this.item
              .find("[data-inventory] .productView-info-value")
              .text(window.inventory_text.outOfStock);
          }
        }

        hotStock(inventoryQuantity);
      }
    }

    if (this.item.find(".productView-stickyCart").length > 0) {
      const sticky = this.item.find(".productView-stickyCart");
      const optionSticky = sticky.find(".select__select");

      optionSticky.val(this.currentVariant.id);
    }
  }

  updateProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const description = `[data-product-description-${this.dataset.product}]`;
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destinationDesc = document.querySelector(description);
        const sourceDesc = html.querySelector(description);

        if (sourceDesc && destinationDesc) {
          destinationDesc.innerHTML = sourceDesc.innerHTML;
          if (destinationDesc.closest(".toggle-content--height")) {
            destinationDesc.style.maxHeight = null;
          }
        }
      });
  }

  updateAttribute(unavailable = true, disable = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.product}`)
      ?.querySelector('[name="add"]');
    var quantityInput = this.item.find('input[name="quantity"]'),
      notifyMe = this.item.find(".productView-notifyMe"),
      hotStock = this.item.find(".productView-hotStock"),
      maxValue = parseInt(quantityInput.attr("data-inventory-quantity"));

    if (unavailable) {
      var text = window.variantStrings.unavailable;

      quantityInput.attr("disabled", true);
      notifyMe.slideUp("slow");
      addButton.setAttribute("disabled", true);
      addButton.textContent = text;
      quantityInput.closest("quantity-input").addClass("disabled");

      if (hotStock.length > 0) hotStock.addClass("is-hiden");
    } else {
      if (disable) {
        var text = window.variantStrings.soldOut;

        quantityInput.attr("data-price", this.currentVariant?.price);
        quantityInput.attr("disabled", true);
        addButton.setAttribute("disabled", true);
        addButton.textContent = text;
        quantityInput.closest("quantity-input").addClass("disabled");

        if (notifyMe.length > 0) {
          notifyMe
            .find('input[name="halo-notify-product-variant"]')
            .val(this.currentVariant.title);
          notifyMe.find(".notifyMe-text").empty();
          notifyMe.slideDown("slow");
        }
      } else {
        var text,
          subTotal = 0,
          price = this.currentVariant?.price;

        const stickyPrice = $(
          "[data-sticky-add-to-cart] .money-subtotal .money"
        );
        const stickyComparePrice = $(
          "[data-sticky-add-to-cart] .money-compare-price .money"
        );

        if (window.subtotal.show) {
          let qty = quantityInput.val();

          subTotal = qty * price;
          subTotal = Shopify.formatMoney(subTotal, window.money_format);
          subTotal = extractContent(subTotal);

          const moneySpan = document.createElement("span");
          moneySpan.classList.add(
            window.currencyFormatted ? "money" : "money-subtotal"
          );
          moneySpan.innerText = subTotal;
          document.body.appendChild(moneySpan);

          if (this.checkNeedToConvertCurrency()) {
            let currencyCode = document
              .getElementById("currencies")
              ?.querySelector(".active")
              ?.getAttribute("data-currency");
            Currency.convertAll(
              window.shop_currency,
              currencyCode,
              "span.money",
              "money_format"
            );
          }

          subTotal = moneySpan.innerText;
          $(moneySpan).remove();

          if (window.subtotal.style == "1") {
            const pdView_subTotal =
              document.querySelector(".productView-subtotal .money") ||
              document.querySelector(".productView-subtotal .money-subtotal");
            if (pdView_subTotal != null) {
              pdView_subTotal.textContent = subTotal;
            }

            if (
              this.currentVariant.available &&
              maxValue <= 0 &&
              this.currentVariant.inventory_management == "shopify"
            ) {
              text = window.variantStrings.preOrder;
            } else {
              text = window.variantStrings.addToCart;
            }
          } else if (window.subtotal.style == "2") {
            text = window.subtotal.text.replace("[value]", subTotal);
          }
        } else {
          subTotal = Shopify.formatMoney(price, window.money_format);
          subTotal = extractContent(subTotal);
          if (
            this.currentVariant.available &&
            maxValue <= 0 &&
            this.currentVariant.inventory_management == "shopify"
          ) {
            text = window.variantStrings.preOrder;
          } else {
            text = window.variantStrings.addToCart;
          }
        }

        quantityInput.attr("data-price", this.currentVariant?.price);
        quantityInput.attr("disabled", false);
        addButton.removeAttribute("disabled");
        addButton.textContent = text;
        quantityInput.closest("quantity-input").removeClass("disabled");

        if (subTotal != 0 && stickyPrice.length) {
          stickyPrice.text(subTotal);
        }

        if (
          subTotal != 0 &&
          stickyComparePrice.length &&
          window.subtotal.show
        ) {
          let comparePrice = $(
              "[data-sticky-add-to-cart] .money-compare-price"
            ).data("compare-price"),
            qty = quantityInput.val();
          comparePrice = qty * comparePrice;
          comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
          comparePrice = extractContent(comparePrice);
          stickyComparePrice.text(comparePrice);
        }

        if (notifyMe.length > 0) {
          notifyMe.slideUp("slow");
        }
      }
    }
  }

  updateStickyAddToCart(unavailable = true, disable = true) {
    if (this.item.find(".productView-stickyCart").length > 0) {
      const sticky = this.item.find(".productView-stickyCart");
      const itemImage = sticky.find(".sticky-image");
      const option = sticky.find(".select__select");
      const input = document
        .getElementById(`product-form-sticky-${this.dataset.product}`)
        ?.querySelector('input[name="id"]');
      const button = document
        .getElementById(`product-form-sticky-${this.dataset.product}`)
        ?.querySelector('[name="add"]');
      var quantityInput = this.item.find('input[name="quantity"]');
      var maxValue = parseInt(quantityInput.attr("data-inventory-quantity"));

      if (unavailable) {
        var text = window.variantStrings.unavailable;

        button.setAttribute("disabled", true);
        button.textContent = text;
      } else {
        if (!this.currentVariant) return;

        const image = this.currentVariant?.featured_image;

        if (image != null) {
          itemImage.find("img").attr({
            src: image.src,
            srcset: image.src,
            alt: image.alt,
          });
        }

        option.val(this.currentVariant.id);

        if (disable) {
          var text = window.variantStrings.soldOut;

          button.setAttribute("disabled", true);
          button.textContent = text;
        } else {
          if (
            this.currentVariant.available &&
            maxValue <= 0 &&
            this.currentVariant.inventory_management == "shopify"
          ) {
            text = window.variantStrings.preOrder;
          } else {
            text = window.variantStrings.addToCart;
          }

          button.removeAttribute("disabled");
          button.textContent = text;
        }

        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  checkQuantityWhenVariantChange() {
    var quantityInput = this.closest(".productView-details").querySelector(
      "input.quantity__input"
    );
    var maxValue = parseInt(quantityInput?.dataset.inventoryQuantity);
    var inputValue = parseInt(quantityInput?.value);

    let value = inputValue;

    if (inputValue > maxValue && maxValue > 0) {
      value = maxValue;
    } else {
      value = inputValue;
    }

    if (value < 1 || isNaN(value)) value = 1;

    if (quantityInput) {
      quantityInput.value = value;
    }

    document.getElementById("product-add-to-cart").dataset.available =
      this.currentVariant.available && maxValue <= 0;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );

    if (!this.checkHasMultipleVariants()) {
      this.initProductQuantity();
      this.checkVariantInventory();
    }
  }

  onInputChange(event) {
    event.preventDefault();
    var inputValue = this.input.value;
    var maxValue = parseInt(this.input.dataset.inventoryQuantity);
    var currentId = document
      .getElementById(`product-form-${this.input.dataset.product}`)
      ?.querySelector('[name="id"]')?.value;
    var saleOutStock =
      document.getElementById("product-add-to-cart").dataset.available ===
        "true" || false;
    const addButton = document
      .getElementById(`product-form-${this.input.dataset.product}`)
      ?.querySelector('[name="add"]');

    if (inputValue < 1) {
      inputValue = 1;

      this.input.value = inputValue;
    }

    if (inputValue > maxValue && !saleOutStock && maxValue > 0) {
      var arrayInVarName = `selling_array_${this.input.dataset.product}`,
        itemInArray = window[arrayInVarName],
        itemStatus = itemInArray[currentId];

      if (itemStatus == "deny") {
        inputValue = maxValue;
        this.input.value = inputValue;
        const message = getInputMessage(maxValue);
        showWarning(message, 3000);
      }
    } else if (inputValue > maxValue && saleOutStock && maxValue <= 0) {
      this.input.value = inputValue;
    }

    if (window.subtotal.show) {
      var text,
        price = this.input.dataset.price,
        subTotal = 0;

      var parser = new DOMParser();

      subTotal = inputValue * price;
      subTotal = Shopify.formatMoney(subTotal, window.money_format);
      subTotal = extractContent(subTotal);

      const moneySpan = document.createElement("span");
      moneySpan.classList.add(
        window.currencyFormatted ? "money" : "money-subtotal"
      );
      moneySpan.innerText = subTotal;
      document.body.appendChild(moneySpan);

      if (this.checkNeedToConvertCurrency()) {
        let currencyCode = document
          .getElementById("currencies")
          ?.querySelector(".active")
          ?.getAttribute("data-currency");
        Currency.convertAll(
          window.shop_currency,
          currencyCode,
          "span.money",
          "money_format"
        );
      }

      subTotal = moneySpan.innerText;
      $(moneySpan).remove();

      if (window.subtotal.style == "1") {
        const pdView_subTotal =
          document.querySelector(".productView-subtotal .money") ||
          document.querySelector(".productView-subtotal .money-subtotal");

        pdView_subTotal.textContent = subTotal;
      } else if (window.subtotal.style == "2") {
        text = window.subtotal.text.replace("[value]", subTotal);

        addButton.textContent = text;
      }

      const stickyPrice = $("[data-sticky-add-to-cart] .money-subtotal .money");
      const stickyComparePrice = $(
        "[data-sticky-add-to-cart] .money-compare-price .money"
      );

      if (stickyPrice.length) {
        stickyPrice.text(subTotal);
      }

      if (stickyComparePrice.length && window.subtotal.show) {
        let comparePrice = $(
          "[data-sticky-add-to-cart] .money-compare-price"
        ).data("compare-price");
        comparePrice = inputValue * comparePrice;
        comparePrice = Shopify.formatMoney(comparePrice, window.money_format);
        comparePrice = extractContent(comparePrice);
        stickyComparePrice.text(comparePrice);
      }
    }

    if (
      this.classList.contains("quantity__group--2") ||
      this.classList.contains("quantity__group--3")
    ) {
      const mainQty = document.querySelector(
        ".quantity__group--1 .quantity__input"
      );
      mainQty.value = inputValue;

      const mainQty2Exists = !!document.querySelector(
        ".quantity__group--2 .quantity__input"
      );
      const mainQty3Exists = !!document.querySelector(
        ".quantity__group--3 .quantity__input"
      );

      if (this.classList.contains("quantity__group--2") && mainQty3Exists) {
        const mainQty3 = document.querySelector(
          ".quantity__group--3 .quantity__input"
        );
        mainQty3.value = inputValue;
      } else if (
        this.classList.contains("quantity__group--3") &&
        mainQty2Exists
      ) {
        const mainQty2 = document.querySelector(
          ".quantity__group--2 .quantity__input"
        );
        mainQty2.value = inputValue;
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }

  checkHasMultipleVariants() {
    const arrayInVarName = `product_inven_array_${
      this.querySelector("[data-product]").dataset.product
    }`;
    this.inven_array = window[arrayInVarName];
    return Object.keys(this.inven_array).length > 1;
  }

  initProductQuantity() {
    if (this.inven_array != undefined) {
      var inven_num = Object.values(this.inven_array),
        inventoryQuantity = parseInt(inven_num);

      this.querySelector('input[name="quantity"]').setAttribute(
        "data-inventory-quantity",
        inventoryQuantity
      );
      this.querySelector('input[name="quantity"]').dataset.inventoryQuantity =
        inventoryQuantity;
    }
  }

  checkVariantInventory() {
    const addBtn = document.getElementById("product-add-to-cart");
    this.input.disabled = addBtn.disabled;
    this.querySelector(".btn-quantity.minus").disabled = addBtn.disabled;
    this.querySelector(".btn-quantity.plus").disabled = addBtn.disabled;
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        document.querySelector('.product-option [type="application/json"]')
          .textContent
      );
    return this.variantData;
  }
}

customElements.define("quantity-input", QuantityInput);

function hotStock(inventoryQuantity) {
  const productView = document.querySelector(".productView");
  const hotStock = productView.querySelector(".productView-hotStock");
  if (hotStock) {
    let hotStockText = hotStock.querySelector(".hotStock-text"),
      maxStock = parseFloat(hotStock.dataset.hotStock),
      textStock;

    if (inventoryQuantity > 0 && inventoryQuantity <= maxStock) {
      hotStock.matches(".style-2")
        ? (textStock = window.inventory_text.hotStock2.replace(
            "[inventory]",
            inventoryQuantity
          ))
        : (textStock = window.inventory_text.hotStock.replace(
            "[inventory]",
            inventoryQuantity
          ));
      hotStockText.innerHTML = textStock;
      hotStock.classList.remove("is-hide");
    } else {
      hotStock.classList.add("is-hide");
    }

    if (hotStock.matches(".style-2")) {
      const invenProgress = (inventoryQuantity / maxStock) * 100,
        hotStockProgressItem = hotStock.querySelector(
          ".hotStock-progress-item"
        );
      hotStockProgressItem.style.width = `${invenProgress}%`;
    }
  }
}
const hotStockNoOptions = document.querySelector(
  ".productView .productView-hotStock[data-current-inventory]"
);
if (hotStockNoOptions) {
  const inventoryQuantity = parseFloat(
    hotStockNoOptions.dataset.currentInventory
  );
  hotStock(inventoryQuantity);
}

function showWarning(content, time = null) {
  if (window.warningTimeout) {
    clearTimeout(window.warningTimeout);
  }
  const warningPopupContent = document
    .getElementById("halo-warning-popup")
    .querySelector("[data-halo-warning-content]");
  warningPopupContent.textContent = content;
  document.body.classList.add("has-warning");

  if (time) {
    window.warningTimeout = setTimeout(() => {
      document.body.classList.remove("has-warning");
    }, time);
  }
}

function getInputMessage(maxValue) {
  var message = window.cartStrings.addProductOutQuantity.replace(
    "[maxQuantity]",
    maxValue
  );
  return message;
}

// document.addEventListener('updateMainPrice', () => {
//   var selectedval = $('input[name="gold-purity"]:checked').val();
//   var mainprice = Number(
//     $(".main-selected-var-price").attr("data-price")
//   );
//   var maincompprice = Number(
//     $(".main-selected-var-price").attr("data-compprice")
//   );
//   var maincategory = $('#productCategoryMain').attr('value');
//   var shippingMethod = $('input[name="shipping-method"]:checked').val(); 
//   if ($(".purity-options").length > 0) {
//     $('input[name="properties[Gold Purity]"]').attr('value',selectedval);
//     if(selectedval == '10K'){
//       mainprice = mainprice; // No change for 10 Karat
//       maincompprice = maincompprice;
//     }
//     if(selectedval == '14K'){
//       if(maincategory == 'Earrings'){
//         mainprice = mainprice + (Shopify.currency.rate * 5000);
//         maincompprice = maincompprice + (Shopify.currency.rate * 5000);
//       }else{
//         mainprice = mainprice + (Shopify.currency.rate * 10000);
//         maincompprice = maincompprice + (Shopify.currency.rate * 10000);
//       }
//     }
//     if(selectedval == '18K'){
//       if(maincategory == 'Earrings'){
//           mainprice = mainprice + (Shopify.currency.rate * 10000);
//           maincompprice = maincompprice + (Shopify.currency.rate * 10000);
//       }else{
//         mainprice = mainprice + (Shopify.currency.rate * 20000);
//         maincompprice = maincompprice + (Shopify.currency.rate * 20000);
//       }
//     }
//   }
//   console.log(mainprice)
//   if($('.shipping-options').attr('data-isbracelet') == "true"){
//     $('.express-cost').html('+ ' + Shopify.formatMoney(mainprice * 0.60));
//   } else {
//     $('.express-cost').html('+ ' + Shopify.formatMoney(mainprice * 0.30))
//   }
//   console.log(shippingMethod)
//   if (shippingMethod == 'regular') {
//     $('.price-item--regular').html(Shopify.formatMoney(mainprice));
//     $('.price-item--sale').html(Shopify.formatMoney(mainprice));
//     $('.price__compare .price-item--regular').html(Shopify.formatMoney(maincompprice));
//     $('input[name="properties[_DynamicPrice]"]').attr('value', mainprice);
//     $('input[name="properties[Production Method]"]').attr('value', 'Regular Production');
    
//   }
  

//   if (shippingMethod == 'express') {
//     if($('.shipping-options').attr('data-isbracelet') == "true"){
//       mainprice = mainprice * 1.6; 
//     } else {
//       mainprice = mainprice * 1.3; 
//     }

//     $('.price-item--regular').html(Shopify.formatMoney(mainprice));
//     $('.price-item--sale').html(Shopify.formatMoney(mainprice));
//     $('.price__compare .price-item--regular').html(Shopify.formatMoney(maincompprice));
//     $('input[name="properties[_DynamicPrice]"]').attr('value', mainprice);
//     $('input[name="properties[Production Method]"]').attr('value', 'Express Production');
//   }
//   updateShippingTime();
// })
function getSelectedBackingTypeValue() {
  var backingVal = '';

  if ($('input[name="backingtype"]').length) {
    backingVal = $('input[name="backingtype"]:checked').val() || '';
  }

  if (!backingVal && $('.custom-v1-option-radio[data-option-handle="backing-type"]').length) {
    backingVal = $('.custom-v1-option-radio[data-option-handle="backing-type"]:checked').attr('data-option-label') || '';
  }

  if (!backingVal) {
    var backingTheme = document.querySelector('input[data-option-name="Backing Type"]:checked, input[name="Backing Type"]:checked');
    if (backingTheme) {
      backingVal = backingTheme.value || backingTheme.getAttribute('data-option-label') || '';
    }
  }

  return String(backingVal || '').trim();
}

function getSelectedCustomOptionLabel(handle) {
  var $selected = $('.custom-v1-option-radio[data-option-handle="' + handle + '"]:checked');
  return $selected.length ? String($selected.attr('data-option-label') || '').trim() : '';
}


function rbNormalizeOptionKey(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/\([^)]*\)/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

function rbIsBandwidthOption(value) {
  return rbNormalizeOptionKey(value) === 'bandwidth';
}

function getSelectedNestedOptionLabel(name) {
  var el = document.querySelector('input[name^="' + name + '_"]:checked');
  return el ? String(el.getAttribute('data-option-label') || el.value || '').trim() : '';
}

function getSelectedGoldPurityNumber() {
  var purityVal = '';

  if ($('.purity-radio').length) {
    purityVal = $('.purity-radio:checked').val() || '';
  }

  if (!purityVal) {
    var nestedGoldPurityChecked = document.querySelector('input[name^="nested_gold_purity_"]:checked');
    if (nestedGoldPurityChecked) {
      purityVal = String(nestedGoldPurityChecked.value || '').trim();
    }
  }

  if (!purityVal) {
    purityVal = getSelectedCustomOptionLabel('gold-purity');
  }

  var purityNum = purityVal && purityVal.match(/(\d+(\.\d+)?)/);
  return purityNum ? parseFloat(purityNum[0]) : null;
}

function getSelectedSizeValue() {
  var alignmentVal = $('input[name="alignment"]:checked').val();

  if (alignmentVal && !/DON'T\s*KNOW/i.test(alignmentVal)) {
    var sizeNum = alignmentVal.match(/(\d+(\.\d+)?)/);
    if (sizeNum) return parseFloat(sizeNum[0]);
  }

  var braceletSize = getSelectedCustomOptionLabel('bracelet-size') || getSelectedCustomOptionLabel('size');

  if (braceletSize) {
    var braceletSizeNum = braceletSize.match(/(\d+(\.\d+)?)/);
    if (braceletSizeNum) return parseFloat(braceletSizeNum[0]);
  }

  return null;
}

function getShopifyProductId() {
  return Number(
    $('[data-shopify-product-id]').val() ||
    $('[data-shopify-product-id]').attr('value') ||
    $('[data-nested-v1-wrapper]').attr('data-product-id') ||
    $('input[name="product-id"]').val() ||
    $('input[name="product_id"]').val() ||
    0
  ) || null;
}

function getSelectedThemeWeightValue() {
  var el =
    document.querySelector('input[data-option-name="Gemstone Weight"]:checked') ||
    document.querySelector('input[name="Gemstone Weight"]:checked') ||
    document.querySelector('input[data-option-name="Diamond Weight"]:checked') ||
    document.querySelector('input[name="Diamond Weight"]:checked') ||
    document.querySelector('input[name^="nested_gemstone_weight_"]:checked') ||
    document.querySelector('input[name^="nested_diamond_weight_"]:checked');

  return el ? String(el.value || el.getAttribute('data-option-label') || '').trim() : '';
}

function getSelectedThemeGemstoneTypeValue() {
  var el =
    document.querySelector('input[data-option-name="Gemstone Type"]:checked') ||
    document.querySelector('input[name="Gemstone Type"]:checked') ||
    document.querySelector('input[data-option-name="Diamond Color"]:checked') ||
    document.querySelector('input[name="Diamond Color"]:checked') ||
    document.querySelector('input[name^="nested_gemstone_type_"]:checked') ||
    document.querySelector('input[name^="nested_diamond_color_"]:checked');

  return el ? String(el.value || el.getAttribute('data-option-label') || '').trim() : '';
}

function getCenterDiamondPayload() {
  var carat = '';
  var color = '';
  var clarity = '';

  var nestedWeight =
    document.querySelector('input[name^="nested_diamond_weight_"]:checked') ||
    document.querySelector('input[name^="nested_gemstone_weight_"]:checked') ||
    document.querySelector('input[data-option-name="Diamond Weight"]:checked') ||
    document.querySelector('input[data-option-name="Gemstone Weight"]:checked') ||
    document.querySelector('input[name="Diamond Weight"]:checked') ||
    document.querySelector('input[name="Gemstone Weight"]:checked');

  var nestedColor =
    document.querySelector('input[name^="nested_diamond_color_"]:checked') ||
    document.querySelector('input[name^="nested_gemstone_type_"]:checked') ||
    document.querySelector('input[data-option-name="Diamond Color"]:checked') ||
    document.querySelector('input[data-option-name="Gemstone Type"]:checked') ||
    document.querySelector('input[name="Diamond Color"]:checked') ||
    document.querySelector('input[name="Gemstone Type"]:checked');

  var nestedClarity = document.querySelector('input[name^="nested_diamond_clarity_"]:checked');

  if (nestedWeight) carat = String(nestedWeight.value || nestedWeight.getAttribute('data-option-label') || '').trim();
  if (nestedColor) color = String(nestedColor.value || nestedColor.getAttribute('data-option-label') || '').trim();
  if (nestedClarity) clarity = String(nestedClarity.value || nestedClarity.getAttribute('data-option-label') || '').trim();

  if (!carat) {
    carat = getSelectedCustomOptionLabel('diamond-weight') || getSelectedCustomOptionLabel('gemstone-weight');
  }

  if (!color) {
    color =
      getSelectedCustomOptionLabel('diamond-color') ||
      getSelectedCustomOptionLabel('gemstone-type');
  }

  if (!clarity) {
    clarity = getSelectedCustomOptionLabel('diamond-clarity');
  }

  function extractNumber(val) {
    var m = String(val || '').match(/(\d+(\.\d+)?)/);
    return m ? parseFloat(m[0]) : null;
  }

  return {
    center_diamond_carat: extractNumber(carat),
    center_diamond_color: color || null,
    center_diamond_clarity: clarity || null
  };
}


function rbReadNestedVariantJsonForFixPrice() {
  var el = document.querySelector('[data-nested-variant-json]');
  if (!el) return null;

  try {
    return JSON.parse(el.textContent || '{}');
  } catch (err) {
    console.warn('Invalid nested variant JSON for fixed price', err);
    return null;
  }
}

function rbGetSelectedPropertyValueForFixPrice(name) {
  var el = document.querySelector('[data-nested-property="' + name + '"]');
  if (el && String(el.value || el.getAttribute('value') || '').trim()) {
    return String(el.value || el.getAttribute('value') || '').trim();
  }

  el = document.querySelector('input[data-option-name="' + name + '"]:checked, input[name="' + name + '"]:checked');
  if (el) {
    return String(el.getAttribute('data-option-label') || el.value || '').trim();
  }

  return '';
}

function rbExtractNumberForFixPrice(value) {
  var match = String(value || '').match(/(\d+(?:\.\d+)?)/);
  return match ? Number(match[1]) : null;
}

function rbNormalizeForFixPrice(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ');
}

function rbCompareFixPriceValue(key, selectedValue, ruleValue) {
  if (selectedValue === '' || selectedValue == null || ruleValue == null) return false;

  var selectedNumber = rbExtractNumberForFixPrice(selectedValue);
  var ruleNumber = rbExtractNumberForFixPrice(ruleValue);

  if (
    key === 'Diamond Weight' ||
    key === 'Gemstone Weight' ||
    key === 'Gold Purity' ||
    typeof ruleValue === 'number'
  ) {
    return selectedNumber !== null && ruleNumber !== null && Math.abs(selectedNumber - ruleNumber) < 0.0001;
  }

  return rbNormalizeForFixPrice(selectedValue) === rbNormalizeForFixPrice(ruleValue);
}

function rbFindSelectedFixPriceMatch() {
  var data = rbReadNestedVariantJsonForFixPrice();
  var list = data && Array.isArray(data.lstFixPrice) ? data.lstFixPrice : [];
  if (!list.length) return null;

  var selectedValues = {
    'Diamond Weight': rbGetSelectedPropertyValueForFixPrice('Diamond Weight') || rbGetSelectedPropertyValueForFixPrice('Gemstone Weight'),
    'Gemstone Weight': rbGetSelectedPropertyValueForFixPrice('Gemstone Weight') || rbGetSelectedPropertyValueForFixPrice('Diamond Weight'),
    'Gold Purity': rbGetSelectedPropertyValueForFixPrice('Gold Purity'),
    'Diamond Color': rbGetSelectedPropertyValueForFixPrice('Diamond Color') || rbGetSelectedPropertyValueForFixPrice('Gemstone Type'),
    'Gemstone Type': rbGetSelectedPropertyValueForFixPrice('Gemstone Type') || rbGetSelectedPropertyValueForFixPrice('Diamond Color'),
    'Diamond Clarity': rbGetSelectedPropertyValueForFixPrice('Diamond Clarity')
  };

  return list.find(function (rule) {
    if (!rule || rule.fix_price == null || rule.fix_price === '') return false;

    return Object.keys(rule).every(function (key) {
      if (key === 'fix_price' || key === 'compare_at_price' || key === 'fix_compare_price') return true;
      return rbCompareFixPriceValue(key, selectedValues[key], rule[key]);
    });
  }) || null;
}

document.addEventListener('updateMainPrice', () => {
  var selectedval = $('input[name="gold-purity"]:checked').val();
  var nestedGoldSelected = document.querySelector('input[name^="nested_gold_purity_"]:checked');

  if (!selectedval && nestedGoldSelected) {
    selectedval = nestedGoldSelected.value || nestedGoldSelected.getAttribute('data-option-label') || '';
  }

  var mainprice = Number($(".main-selected-var-price").attr("data-price"));
  var maincompprice = Number($(".main-selected-var-price").attr("data-compprice"));
  var maincategory = $('#productCategoryMain').attr('value');
  var shippingMethod = $('input[name="shipping-method"]:checked').val();
  var selectedFixPrice = rbFindSelectedFixPriceMatch();
  var hasSelectedFixPrice = selectedFixPrice && selectedFixPrice.fix_price != null && selectedFixPrice.fix_price !== '';

  if (hasSelectedFixPrice) {
    mainprice = (Number(selectedFixPrice.fix_price) || 0) * 100 * Shopify.currency.rate;

    if (selectedFixPrice.fix_compare_price != null || selectedFixPrice.compare_at_price != null) {
      maincompprice = (Number(selectedFixPrice.fix_compare_price || selectedFixPrice.compare_at_price) || 0) * 100 * Shopify.currency.rate;
    } else {
      maincompprice = mainprice;
    }
  }

  /*
    Only apply old static purity pricing when normal .purity-options exists.
    If Gold Purity is coming from JSON nested options, its price is added below from:
    [data-nested-price-property="Gold Purity"]
  */
  if (!hasSelectedFixPrice && $(".purity-options").length > 0 && $('[data-nested-price-property="Gold Purity"]').length === 0) {
    $('input[name="properties[Gold Purity]"]').attr('value', selectedval);

    if (selectedval == '10K') {
      mainprice = mainprice;
      maincompprice = maincompprice;
    }

    if (selectedval == '14K') {
      if (maincategory == 'Earrings') {
        mainprice = mainprice + (Shopify.currency.rate * 5000);
        maincompprice = maincompprice + (Shopify.currency.rate * 5000);
      } else {
        mainprice = mainprice + (Shopify.currency.rate * 10000);
        maincompprice = maincompprice + (Shopify.currency.rate * 10000);
      }
    }

    if (selectedval == '18K') {
      if (maincategory == 'Earrings') {
        mainprice = mainprice + (Shopify.currency.rate * 10000);
        maincompprice = maincompprice + (Shopify.currency.rate * 10000);
      } else {
        mainprice = mainprice + (Shopify.currency.rate * 20000);
        maincompprice = maincompprice + (Shopify.currency.rate * 20000);
      }
    }
  }

  // Bandwidth / percentage increase must be applied AFTER JSON/custom option prices.
  // Supports both old .bandwidth-percentage__radio and JSON-rendered custom option Bandwidth.
  var selectedBandwidth = $('.bandwidth-percentage__radio:checked');
  var selectedJsonBandwidth = $('.custom-v1-option-radio:checked').filter(function () {
    return rbIsBandwidthOption($(this).attr('data-option-handle')) || rbIsBandwidthOption($(this).attr('data-option-name'));
  });
  var bandwidthPercentage = 0;

  if ($(".bandwidth-percentage__radio").length > 0 && selectedBandwidth.length > 0) {
    bandwidthPercentage = Number(selectedBandwidth.attr('data-percentage')) || 0;

    if ($('input[name="properties[Bandwidth]"]').length > 0) {
      $('input[name="properties[Bandwidth]"]').attr('value', selectedBandwidth.attr('data-bandwidth') || '');
      $('input[name="properties[Bandwidth]"]').val(selectedBandwidth.attr('data-bandwidth') || '');
    }

    if ($('input[name="properties[_Bandwidth_Percentage]"]').length > 0) {
      $('input[name="properties[_Bandwidth_Percentage]"]').attr('value', bandwidthPercentage);
      $('input[name="properties[_Bandwidth_Percentage]"]').val(bandwidthPercentage);
    }
  }

  if (selectedJsonBandwidth.length > 0) {
    bandwidthPercentage = Number(selectedJsonBandwidth.attr('data-percentage')) || 0;

    if ($('input[name="properties[Bandwidth]"]').length > 0) {
      var jsonBandwidthLabel = selectedJsonBandwidth.attr('data-option-label') || selectedJsonBandwidth.val() || '';
      $('input[name="properties[Bandwidth]"]').attr('value', jsonBandwidthLabel);
      $('input[name="properties[Bandwidth]"]').val(jsonBandwidthLabel);
    }

    if ($('input[name="properties[_Bandwidth_Percentage]"]').length > 0) {
      $('input[name="properties[_Bandwidth_Percentage]"]').attr('value', bandwidthPercentage);
      $('input[name="properties[_Bandwidth_Percentage]"]').val(bandwidthPercentage);
    }
  }

  if ($('.custom-v1-option-radio').length > 0) {
    $('.custom-v1-option-fieldset').each(function () {
      var $fieldset = $(this);
      var optionHandle = $fieldset.attr('data-option-handle');
      var $selected = $fieldset.find('.custom-v1-option-radio:checked');

      if ($selected.length > 0) {
        var optionLabel = $selected.attr('data-option-label') || '';
        var optionPrice = Number($selected.attr('data-price')) || 0;
        var optionComparePrice = Number($selected.attr('data-compare-price')) || 0;
        var convertedOptionPrice = (optionPrice * 100) * Shopify.currency.rate;
        var convertedOptionComparePrice = (optionComparePrice * 100) * Shopify.currency.rate;

        if (!hasSelectedFixPrice && convertedOptionPrice > 0) {
          mainprice = mainprice + convertedOptionPrice;
        }

        if (!hasSelectedFixPrice && convertedOptionComparePrice > 0) {
          maincompprice = maincompprice + convertedOptionComparePrice;
        } else if (!hasSelectedFixPrice && convertedOptionPrice > 0) {
          maincompprice = maincompprice + convertedOptionPrice;
        }

        $('[data-custom-option-property="' + optionHandle + '"]').val(optionLabel);
        $('[data-custom-option-property="' + optionHandle + '"]').attr('value', optionLabel);

        $('[data-custom-option-price-property="' + optionHandle + '"]').val(optionPrice * 100);
        $('[data-custom-option-price-property="' + optionHandle + '"]').attr('value', optionPrice * 100);

        $('[data-custom-option-compare-price-property="' + optionHandle + '"]').val(optionComparePrice * 100);
        $('[data-custom-option-compare-price-property="' + optionHandle + '"]').attr('value', optionComparePrice * 100);
      }
    });
  }

  if ($('[data-nested-v1-wrapper]').length > 0 || $('[data-nested-price-property]').length > 0) {
    var nestedWeightPrice =
      Number($('[data-nested-price-property="Diamond Weight"]').val() || 0) ||
      Number($('[data-nested-price-property="Gemstone Weight"]').val() || 0);

    var nestedColorPrice =
      Number($('[data-nested-price-property="Diamond Color"]').val() || 0) ||
      Number($('[data-nested-price-property="Gemstone Type"]').val() || 0);

    var nestedClarityPrice = Number($('[data-nested-price-property="Diamond Clarity"]').val() || 0);
    var nestedGoldPurityPrice = Number($('[data-nested-price-property="Gold Purity"]').val() || 0);

    var nestedWeightComparePrice =
      Number($('[data-nested-compare-price-property="Diamond Weight"]').val() || 0) ||
      Number($('[data-nested-compare-price-property="Gemstone Weight"]').val() || 0);

    var nestedColorComparePrice =
      Number($('[data-nested-compare-price-property="Diamond Color"]').val() || 0) ||
      Number($('[data-nested-compare-price-property="Gemstone Type"]').val() || 0);

    var nestedClarityComparePrice = Number($('[data-nested-compare-price-property="Diamond Clarity"]').val() || 0);
    var nestedGoldPurityComparePrice = Number($('[data-nested-compare-price-property="Gold Purity"]').val() || 0);

    var nestedTotal = nestedWeightPrice + nestedColorPrice + nestedClarityPrice + nestedGoldPurityPrice;
    var nestedCompareTotal = nestedWeightComparePrice + nestedColorComparePrice + nestedClarityComparePrice + nestedGoldPurityComparePrice;
    var convertedNestedTotal = nestedTotal * Shopify.currency.rate;
    var convertedNestedCompareTotal = nestedCompareTotal * Shopify.currency.rate;

    if (!hasSelectedFixPrice && convertedNestedTotal > 0) {
      mainprice = mainprice + convertedNestedTotal;
    }

    if (!hasSelectedFixPrice && convertedNestedCompareTotal > 0) {
      maincompprice = maincompprice + convertedNestedCompareTotal;
    } else if (!hasSelectedFixPrice && convertedNestedTotal > 0) {
      maincompprice = maincompprice + convertedNestedTotal;
    }
  }

  // Apply bandwidth percentage after all selected option prices are added.
  if (!hasSelectedFixPrice && bandwidthPercentage > 0) {
    mainprice = mainprice + ((mainprice * bandwidthPercentage) / 100);
    maincompprice = maincompprice + ((maincompprice * bandwidthPercentage) / 100);
  }

  if ($('.shipping-options').attr('data-isbracelet') == "true") {
    $('.express-cost').html('+ ' + Shopify.formatMoney(mainprice * 0.60));
  } else {
    $('.express-cost').html('+ ' + Shopify.formatMoney(mainprice * 0.30));
  }

  if (shippingMethod == 'regular') {
    $('.price-item--regular').html(Shopify.formatMoney(mainprice));
    $('.price-item--sale').html(Shopify.formatMoney(mainprice));
    $('.price__compare .price-item--regular').html(Shopify.formatMoney(maincompprice));
    $('input[name="properties[_DynamicPrice]"]').attr('value', mainprice);
    $('input[name="properties[_totalPrice]"]').attr('value', mainprice / 100.0);
    $('input[name="properties[Production Method]"]').attr('value', 'Regular Production');
  }

  if (shippingMethod == 'express') {
    if ($('.shipping-options').attr('data-isbracelet') == "true") {
      mainprice = mainprice * 1.6;
    } else {
      mainprice = mainprice * 1.3;
    }

    $('.price-item--regular').html(Shopify.formatMoney(mainprice));
    $('.price-item--sale').html(Shopify.formatMoney(mainprice));
    $('.price__compare .price-item--regular').html(Shopify.formatMoney(maincompprice));
    $('input[name="properties[_DynamicPrice]"]').attr('value', mainprice);
    $('input[name="properties[_totalPrice]"]').attr('value', mainprice / 100.0);
    $('input[name="properties[Production Method]"]').attr('value', 'Express Production');
  }

  if($('input[data-option-name="Gemstone Weight"]:checked').length > 0){
    var gemweight = $('input[data-option-name="Gemstone Weight"]:checked').val().toLowerCase().replace('carat','').trim();
    console.log(gemweight);
    var iframe = $('.earringpreview');
    var currentSrc = iframe.attr('src');
    var url = new URL(currentSrc);

    url.searchParams.set('carat', gemweight);

    iframe.attr('src', url.toString());

    console.log(gemweight);
  }

  updateShippingTime();
});

function updateShippingTime() {
  var variantId = document.querySelector(".asVarId1")?.getAttribute("value");
  var shopifyProductId = getShopifyProductId();
  var diamondPayload = getCenterDiamondPayload();
  var goldPurity = getSelectedGoldPurityNumber();
  var size = getSelectedSizeValue();
  var backingVal = getSelectedBackingTypeValue();

  var data = {
    organization_id: 1
  };

  if (variantId) {
    data.variant_id = Number(variantId);
  }

  if (shopifyProductId) {
    data.shopify_product_id = shopifyProductId;
  }

  if (diamondPayload.center_diamond_carat != null) {
    data.center_diamond_carat = diamondPayload.center_diamond_carat;
  }

  if (diamondPayload.center_diamond_color) {
    data.center_diamond_color = diamondPayload.center_diamond_color;
  }

  if (diamondPayload.center_diamond_clarity) {
    data.center_diamond_clarity = diamondPayload.center_diamond_clarity;
  }

  if (goldPurity != null) {
    data.gold_purity = goldPurity;
  }

  if (size != null) {
    data.size = size;
  } 

  if (backingVal) {
    if (/screw\s*back/i.test(backingVal)) {
      data.backing_type = 1;
    } else if (/push\s*back/i.test(backingVal)) {
      data.backing_type = 2;
    }
  }

  function setDefaultDeliveryText() {
    $('#regular-delivery').html(`Ships Between <span class="date-text"></span>`);

    if ($('.shipping-options').attr('data-isbracelet') == "true") {
      $('#regular-delivery').find('.date-text').html(addRegularDays(15) + ' and ' + addRegularDays(20));
    } else if ($('.shipping-options').attr('data-isstuds') == "true") {
      $('#regular-delivery').find('.date-text').html(addRegularDays(10) + ' and ' + addRegularDays(15));
    } else {
      $('#regular-delivery').find('.date-text').html(addRegularDays(10) + ' and ' + addRegularDays(15));
    }
  }

  $.ajax({
    url: "https://apirj.renaissancejewel.com/api/get-inventory",
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: JSON.stringify(data)
  })
    .done(function (response) {
      if (response && response.success === true && response.data && response.data.inventory_id) {
        $('.productInventoryId').val(response.data.inventory_id);
        $('.shipping-method').find('.shipping-option[for="express_methode"]').hide();
        $('.shipping-method').find('.border-hr').hide();
        $('.shipping-method input[type="radio"][name="shipping-method"][value="regular"]').click();
      } else {
        setDefaultDeliveryText();
        $('.productInventoryId').val('');
        $('.shipping-method').find('.shipping-option[for="express_methode"]').show();
        $('.shipping-method').find('.border-hr').show();
      }

      if (response && response.data && response.data.ships_message) {
        $('#regular-delivery').html('<b style="color:black;">' + response.data.ships_message + '</b>');
      }
    })
    .fail(function () {
      setDefaultDeliveryText();
      $('.productInventoryId').val('');
    });
} 

$(document).on('change', '.custom-v1-option-radio', function () {
  var $selected = $(this);
  var optionHandle = $selected.attr('data-option-handle') || '';
  var optionLabel = $selected.attr('data-option-label') || '';
  var optionPrice = Number($selected.attr('data-price')) || 0;
  var optionComparePrice = Number($selected.attr('data-compare-price')) || 0;
  var optionPercentage = Number($selected.attr('data-percentage')) || 0;

  if (optionHandle) {
    $('[data-custom-option-property="' + optionHandle + '"]').val(optionLabel);
    $('[data-custom-option-property="' + optionHandle + '"]').attr('value', optionLabel);

    $('[data-custom-option-price-property="' + optionHandle + '"]').val(optionPrice * 100);
    $('[data-custom-option-price-property="' + optionHandle + '"]').attr('value', optionPrice * 100);

    $('[data-custom-option-compare-price-property="' + optionHandle + '"]').val(optionComparePrice * 100);
    $('[data-custom-option-compare-price-property="' + optionHandle + '"]').attr('value', optionComparePrice * 100);
  }
   
  if (rbIsBandwidthOption(optionHandle) || rbIsBandwidthOption($selected.attr('data-option-name'))) {
    if ($('input[name="properties[Bandwidth]"]').length > 0) {
      $('input[name="properties[Bandwidth]"]').val(optionLabel);
      $('input[name="properties[Bandwidth]"]').attr('value', optionLabel);
    }

    if ($('input[name="properties[_Bandwidth_Percentage]"]').length > 0) {
      $('input[name="properties[_Bandwidth_Percentage]"]').val(optionPercentage);
      $('input[name="properties[_Bandwidth_Percentage]"]').attr('value', optionPercentage);
    }
  }

  document.dispatchEvent(new Event('updateMainPrice'));
});

$('.purity-radio').change(function () {
  document.dispatchEvent(new Event('updateMainPrice'));
});

$('input[name="shipping-method"]').change(function () {
  document.dispatchEvent(new Event('updateMainPrice'));
});

var currentDate = new Date();

function getOrdinal(day) {
  if (day > 3 && day < 21) return 'th';

  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
}

function formatDateWithOrdinal(date) {
  const month = date.toLocaleString('en-US', { month: 'long' });
  const day = date.getDate();
  const year = date.getFullYear();

  return `${month} ${day}${getOrdinal(day)}, ${year}`;
}

var addBusinessDays = (daysToAdd) => {
  let date = new Date(currentDate);
  let addedDays = 0;

  if (date.getDay() !== 0 && date.getDay() !== 6) {
    addedDays = 1;
  }

  while (addedDays < daysToAdd) {
    date.setDate(date.getDate() + 1);

    const day = date.getDay();

    if (day !== 0 && day !== 6) {
      addedDays++;
    }
  }

  return formatDateWithOrdinal(date);
};

var addRegularDays = (daysToAdd) => {
  let date = new Date(currentDate);
  let addedDays = 0;

  while (addedDays < daysToAdd) {
    date.setDate(date.getDate() + 1);
    addedDays++;
  }

  return formatDateWithOrdinal(date);
};

if ($('.shipping-options').attr('data-isbracelet') == "true") {
  $('#regular-delivery').html(`Ships Between <span class="date-text"></span>`);
  $('#express-delivery').find('.date-text').html(addBusinessDays(8) + ' and ' + addBusinessDays(11));
  $('#regular-delivery').find('.date-text').html(addRegularDays(15) + ' and ' + addRegularDays(20));
} else if ($('.shipping-options').attr('data-isstuds') == "true") {
  $('#regular-delivery').html(`Ships Between <span class="date-text"></span>`);
  $('#express-delivery').find('.date-text').html(addBusinessDays(4) + ' and ' + addBusinessDays(6));
  $('#regular-delivery').find('.date-text').html(addRegularDays(10) + ' and ' + addRegularDays(15));
} else {
  $('#regular-delivery').html(`Ships Between <span class="date-text"></span>`);
  $('#express-delivery').find('.date-text').html(addBusinessDays(4) + ' and ' + addBusinessDays(6));
  $('#regular-delivery').find('.date-text').html(addRegularDays(10) + ' and ' + addRegularDays(15));
}

$(document).ready(function () {
  $('.product-variant-input-radio:not(.is-disabled)').find('input[name="Diamond Color"][value="F-G"]').next().click();
  $('.product-variant-input-radio:not(.is-disabled)').find('input[name="Diamond Purity"][value="VS-SI"]').next().click();

  $('.engraving_input').change(function () {
    $('input[name="properties[engraving]"]').val($(this).val());
  });
});

$(document).ready(function () {
  $('.custom-v1-option-fieldset').each(function () {
    var $fieldset = $(this);
    var optionHandle = $fieldset.attr('data-option-handle');
    var $selected = $fieldset.find('.custom-v1-option-radio:checked');

    if ($selected.length > 0) {
      var optionLabel = $selected.attr('data-option-label') || '';
      var optionPrice = (Number($selected.attr('data-price')) || 0) * 100;
      var optionComparePrice = (Number($selected.attr('data-compare-price')) || 0) * 100;
      var optionPercentage = Number($selected.attr('data-percentage')) || 0;

      $('[data-custom-option-property="' + optionHandle + '"]').val(optionLabel);
      $('[data-custom-option-property="' + optionHandle + '"]').attr('value', optionLabel);

      $('[data-custom-option-price-property="' + optionHandle + '"]').val(optionPrice);
      $('[data-custom-option-price-property="' + optionHandle + '"]').attr('value', optionPrice);

      $('[data-custom-option-compare-price-property="' + optionHandle + '"]').val(optionComparePrice);
      $('[data-custom-option-compare-price-property="' + optionHandle + '"]').attr('value', optionComparePrice);

      if (rbIsBandwidthOption(optionHandle) || rbIsBandwidthOption($selected.attr('data-option-name'))) {
        if ($('input[name="properties[Bandwidth]"]').length > 0) {
          $('input[name="properties[Bandwidth]"]').val(optionLabel);
          $('input[name="properties[Bandwidth]"]').attr('value', optionLabel);
        }

        if ($('input[name="properties[_Bandwidth_Percentage]"]').length > 0) {
          $('input[name="properties[_Bandwidth_Percentage]"]').val(optionPercentage);
          $('input[name="properties[_Bandwidth_Percentage]"]').attr('value', optionPercentage);
        }
      }
    }
  });

  document.dispatchEvent(new Event('updateMainPrice'));
});

$(document).on('change', '.bandwidth-percentage__radio', function () {
  var selectedBandwidth = $('.bandwidth-percentage__radio:checked');

  if (selectedBandwidth.length > 0) {
    if ($('input[name="properties[Bandwidth]"]').length > 0) {
      $('input[name="properties[Bandwidth]"]').attr('value', selectedBandwidth.attr('data-bandwidth') || '');
    }

    if ($('input[name="properties[_Bandwidth_Percentage]"]').length > 0) {
      $('input[name="properties[_Bandwidth_Percentage]"]').attr(
        'value',
        selectedBandwidth.attr('data-percentage') || 0
      );
    }
  }

  document.dispatchEvent(new Event('updateMainPrice'));
});

(function () {
  function qs(sel, ctx) {
    return (ctx || document).querySelector(sel);
  }


  function rbSlugifyOptionName(name) {
    return String(name || '')
      .trim()
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function rbReadPdpNestedJson() {
    var el = document.querySelector('[data-nested-variant-json]');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent || '{}');
    } catch (err) {
      console.warn('Invalid PDP nested variant JSON', err);
      return null;
    }
  }

  function rbGetNestedPriceByName(optionName) {
    var el = document.querySelector('[data-nested-price-property="' + optionName + '"]');
    return el ? (Number(el.value || el.getAttribute('value') || 0) || 0) : 0;
  }

  function rbGetNestedValueByName(optionName) {
    var el = document.querySelector('[data-nested-property="' + optionName + '"]');
    return el ? String(el.value || el.getAttribute('value') || '').trim() : '';
  }

  function rbCollectPdpCustomOptionPayload() {
    var rawData = rbReadPdpNestedJson();
    if (!rawData || !rawData.variant_data) return null;

    var selected = {};
    var selectedList = [];

    document.querySelectorAll('[data-nested-property], [data-custom-option-property]').forEach(function (input) {
      var optionName = input.getAttribute('data-nested-property') || input.getAttribute('name') || '';
      var customHandle = input.getAttribute('data-custom-option-property') || '';
      var label = String(input.value || input.getAttribute('value') || '').trim();

      if (!optionName && customHandle) optionName = customHandle;
      optionName = optionName.replace(/^properties\[/, '').replace(/\]$/, '');

      if (!optionName || !label) return;

      var priceCents = 0;

      if (input.hasAttribute('data-nested-property')) {
        priceCents = rbGetNestedPriceByName(optionName);
      } else if (customHandle) {
        var priceInput = document.querySelector('[data-custom-option-price-property="' + customHandle + '"]');
        priceCents = priceInput ? (Number(priceInput.value || priceInput.getAttribute('value') || 0) || 0) : 0;
      }

      selected[optionName] = {
        label: label,
        price_cents: priceCents,
        price: priceCents / 100
      };

      selectedList.push({
        name: optionName,
        handle: rbSlugifyOptionName(optionName),
        label: label,
        price_cents: priceCents,
        price: priceCents / 100
      });
    });

    // IMPORTANT: Do NOT use _DynamicPrice / _totalPrice here.
    // Ring Builder must calculate its own price from the selected ring base price + selected JSON options.
    var basePriceCents =
      Number($('.main-selected-var-price').attr('data-price') || 0) ||
      Number(document.querySelector('.main-selected-var-price') && document.querySelector('.main-selected-var-price').getAttribute('data-price') || 0) ||
      0;

    var totalOptionsCents = selectedList.reduce(function (sum, item) {
      return sum + (Number(item.price_cents) || 0);
    }, 0);

    return {
      has_custom_json: true,
      source: 'pdp',
      product_id: getShopifyProductId(),
      variant_id: $('.asVarId1').attr('value') || $('input[name="id"]').val() || '',
      product_title: document.querySelector('.productView-title, .product__title, h1') ? String(document.querySelector('.productView-title, .product__title, h1').textContent || '').trim() : '',
      raw_data: rawData,
      selected: selected,
      selected_list: selectedList,
      selected_total_cents: totalOptionsCents,
      selected_total_price: totalOptionsCents / 100,
      base_price_cents: basePriceCents,
      base_price: basePriceCents / 100,
      ts: Date.now()
    };
  }

  function getSelectedRingSize() {
    var checked = qs('.wrapper_siz_chrt input[type="radio"]:checked, .sizeTableTarSec1 input[type="radio"]:checked, .sizeChartOpen input[type="radio"]:checked');

    if (!checked) return '';

    var raw = String(checked.value || '').trim();

    if (!raw) return '';

    var normalized = raw.toLowerCase().replace(/\s+/g, ' ').trim();

    if (
      normalized === "us-don't know" ||
      normalized === "us-dont know" ||
      normalized === "don't know" ||
      normalized.indexOf("know") != -1
    ) {
      return 'dont-know';
    }

    raw = raw.replace(/^us-/i, '').trim();

    return raw;
  }

  function getEngravingValue() {
    var input = qs('.engraving_input');
    return input ? String(input.value || '').trim() : '';
  }

  function getSelectedPurity() {
    var checked =
      qs('input[name="gold-purity"]:checked') ||
      qs('input[name^="nested_gold_purity_"]:checked');

    return checked ? String(checked.value || '').trim() : '';
  }

  function getSelectedBandwidth() {
    var checked = qs('.bandwidth-percentage__radio:checked');

    if (checked) {
      return String(
        checked.getAttribute('data-bandwidth') ||
        checked.value ||
        ''
      ).trim();
    }

    var jsonChecked = Array.prototype.slice.call(document.querySelectorAll('.custom-v1-option-radio:checked')).find(function (el) { return rbIsBandwidthOption(el.getAttribute('data-option-handle')) || rbIsBandwidthOption(el.getAttribute('data-option-name')); }) || null;

    if (jsonChecked) {
      return String(
        jsonChecked.getAttribute('data-option-label') ||
        jsonChecked.value ||
        ''
      ).trim();
    }

    return '';
  }

  function getSelectedPriceIncrease() {
    var checked = qs('.bandwidth-percentage__radio:checked');

    if (checked) {
      return String(
        checked.getAttribute('data-percentage') ||
        ''
      ).trim();
    }

    var jsonChecked = Array.prototype.slice.call(document.querySelectorAll('.custom-v1-option-radio:checked')).find(function (el) { return rbIsBandwidthOption(el.getAttribute('data-option-handle')) || rbIsBandwidthOption(el.getAttribute('data-option-name')); }) || null;

    if (jsonChecked) {
      return String(
        jsonChecked.getAttribute('data-percentage') ||
        ''
      ).trim();
    }

    return '';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rb-builder-link]');

    if (!btn) return;

    e.preventDefault();

    var href = btn.getAttribute('href') || '';

    if (!href) return;

    var url;

    try {
      url = new URL(href, window.location.origin);
    } catch (err) {
      window.location.href = href;
      return;
    }

    var ringSize = getSelectedRingSize();
    var engraving = getEngravingValue();
    var purity = getSelectedPurity();
    var bandwidth = getSelectedBandwidth();
    var priceIncrease = getSelectedPriceIncrease();
    var rbCustomPayload = rbCollectPdpCustomOptionPayload();

    if (rbCustomPayload) {
      try {
        sessionStorage.setItem('rb_v1_custom_options', JSON.stringify(rbCustomPayload));
      } catch (err2) {
        console.warn('Unable to save ring builder custom options in sessionStorage', err2);
      }

      url.searchParams.set('rb_v1', '1');
      url.searchParams.set('rb_v1_selected', encodeURIComponent(JSON.stringify(rbCustomPayload.selected_list || [])));

      if (rbCustomPayload.selected) {
        var selectedWeight =
          rbCustomPayload.selected['Diamond Weight'] ||
          rbCustomPayload.selected['Gemstone Weight'];
        var selectedColor =
          rbCustomPayload.selected['Diamond Color'] ||
          rbCustomPayload.selected['Gemstone Type'];
        var selectedClarity = rbCustomPayload.selected['Diamond Clarity'];
        var selectedGold = rbCustomPayload.selected['Gold Purity'];

        if (selectedWeight && selectedWeight.label) url.searchParams.set('diamond_weight', selectedWeight.label);
        if (selectedColor && selectedColor.label) url.searchParams.set('diamond_color_option', selectedColor.label);
        if (selectedClarity && selectedClarity.label) url.searchParams.set('diamond_clarity', selectedClarity.label);
        if (selectedGold && selectedGold.label) {
          url.searchParams.set('gold_purity', selectedGold.label);
          purity = selectedGold.label;
        }
      }
    } else {
      try {
        sessionStorage.removeItem('rb_v1_custom_options');
      } catch (err3) {}
      url.searchParams.delete('rb_v1');
      url.searchParams.delete('rb_v1_selected');
    }

    if (ringSize) {
      url.searchParams.set('ring_size', ringSize);
    } else {
      url.searchParams.delete('ring_size');
    }

    if (engraving) {
      url.searchParams.set('engraving', engraving);
    } else {
      url.searchParams.delete('engraving');
    }

    if (purity) {
      url.searchParams.set('gold_purity', purity);
    } else {
      url.searchParams.delete('gold_purity');
    }

    if (bandwidth) {
      url.searchParams.set('bandwidth', bandwidth);
    } else {
      url.searchParams.delete('bandwidth');
    }

    // Do not pass PDP dynamic final price.
    // Keep only the percentage increase so Ring Builder can calculate:
    // base ring price + JSON/custom option prices, then apply this percentage.
    if (priceIncrease && priceIncrease !== '0') {
      url.searchParams.set('priceIncrease', priceIncrease);
    } else {
      url.searchParams.delete('priceIncrease');
    }

    window.location.href = url.toString();
  });
})();

/* FORCE FULL FRESH START ON EVERY PAGE OPEN */
(function () {
  function uncheckAll(selector) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.checked = false;
      el.removeAttribute('checked');
      el.defaultChecked = false;
    });
  }

  function clearValues(selector, value) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.value = value;
      el.setAttribute('value', value);
    });
  }

  function clearNestedRenderedOptions() {
    [
      '[data-diamond-color-wrap]',
      '[data-gemstone-type-wrap]',
      '[data-diamond-clarity-wrap]',
      '[data-gold-purity-wrap]'
    ].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) el.innerHTML = '';
    });
  }

  function hardResetOptionState() {
    uncheckAll('.custom-v1-option-radio');
    uncheckAll('.nested-v1-option-radio');
    uncheckAll('.purity-radio');
    uncheckAll('.bandwidth-percentage__radio');
    uncheckAll('input[name^="nested_diamond_weight_"]');
    uncheckAll('input[name^="nested_gemstone_weight_"]');
    uncheckAll('input[name^="nested_diamond_color_"]');
    uncheckAll('input[name^="nested_gemstone_type_"]');
    uncheckAll('input[name^="nested_diamond_clarity_"]');
    uncheckAll('input[name^="nested_gold_purity_"]');

    clearNestedRenderedOptions();

    clearValues('[data-nested-property]', '');
    clearValues('[data-nested-price-property]', 0);
    clearValues('[data-nested-compare-price-property]', 0);
    clearValues('[data-custom-option-property]', '');
    clearValues('[data-custom-option-price-property]', 0);
    clearValues('[data-custom-option-compare-price-property]', 0);
    clearValues('input[name="properties[_Bandwidth_Percentage]"]', 0);

    document.querySelectorAll('.engraving_input').forEach(function (el) {
      el.value = '';
    });

    var engravingProp = document.querySelector('input[name="properties[engraving]"]');

    if (engravingProp) {
      engravingProp.value = '';
      engravingProp.setAttribute('value', '');
    }

    var inventoryId = document.querySelector('.productInventoryId');

    if (inventoryId) {
      inventoryId.value = '';
      inventoryId.setAttribute('value', '');
    }

    $('input[data-option-name="Backing Type"]').eq(0).prop('checked', true);
    $('input[data-option-name="Gemstone Weight"]').eq(0).prop('checked', true);
    $('input[data-option-name="Diamond Weight"]').eq(0).prop('checked', true);
    $('input[data-option-name="Gold Purity"]').eq(0).prop('checked', true);
  }

  function freshInitAll() {
    hardResetOptionState();

    setTimeout(function () {
      hardResetOptionState();

      if (typeof window.initNestedOptions === 'function') {
        window.initNestedOptions(true);
      } else {
        document.dispatchEvent(new CustomEvent('force:nested:init'));
      }

      if (typeof window.renderGoldPurityFromMetafield === 'function') {
        window.renderGoldPurityFromMetafield();
      }

      document.dispatchEvent(new Event('updateMainPrice'));
    }, 30);
  }

  if ($('a[data-rb-builder-link]').length == 0) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', freshInitAll, { once: true });
    } else {
      freshInitAll();
    }

    window.addEventListener('pageshow', function () {
      freshInitAll();
    });
  }
})();

/* NESTED JSON OPTIONS + GEMSTONE WEIGHT GOLD PURITY FIX */
(function () {
  function parseNestedVariantData() {
    var el = document.querySelector('[data-nested-variant-json]');
    if (!el) return null;

    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('Invalid nested variant JSON', e);
      return null;
    }
  }

  function getSelectedRadioValue(name) {
    var el = document.querySelector('input[name="' + name + '"]:checked');
    return el ? String(el.value || '').trim() : '';
  }

  function setNestedProperty(name, value) {
    document.querySelectorAll('[data-nested-property="' + name + '"]').forEach(function (input) {
      input.value = value || '';
      input.setAttribute('value', value || '');
    });
  }

  function setNestedPriceProperty(name, value) {
    document.querySelectorAll('[data-nested-price-property="' + name + '"]').forEach(function (input) {
      input.value = value || 0;
      input.setAttribute('value', value || 0);
    });
  }

  function setNestedComparePriceProperty(name, value) {
    document.querySelectorAll('[data-nested-compare-price-property="' + name + '"]').forEach(function (input) {
      input.value = value || 0;
      input.setAttribute('value', value || 0);
    });
  }

  function ensureNestedPropertyInput(name) {
    var input = document.querySelector('input[name="properties[' + name + ']"][data-nested-property="' + name + '"]');

    if (input) return input;

    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[' + name + ']';
    input.setAttribute('data-nested-property', name);

    var form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form');

    if (form) form.appendChild(input);

    return input;
  }

  function ensureNestedPriceInput(name) {
    var input = document.querySelector('[data-nested-price-property="' + name + '"]');

    if (input) return input;

    input = document.createElement('input');
    input.type = 'hidden';
    input.setAttribute('data-nested-price-property', name);

    var form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form');

    if (form) form.appendChild(input);

    return input;
  }

  function ensureNestedComparePriceInput(name) {
    var input = document.querySelector('[data-nested-compare-price-property="' + name + '"]');

    if (input) return input;

    input = document.createElement('input');
    input.type = 'hidden';
    input.setAttribute('data-nested-compare-price-property', name);

    var form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form');

    if (form) form.appendChild(input);

    return input;
  }

  function getByOptionName(arr, name) {
    if (!Array.isArray(arr)) return null;

    name = String(name || '').trim().toLowerCase();

    return arr.find(function (item) {
      return String(item.option_name || '').trim().toLowerCase() === name;
    }) || null;
  }

  function getOptions(group) {
    if (!group) return [];
    if (Array.isArray(group.Options)) return group.Options;
    if (Array.isArray(group.options)) return group.options;
    return [];
  }

  function getOptionLabel(option) {
    return String(option && (option.name || option.Name) || '').trim();
  }

  function getDeepLowestPrice(option) {
    var ownPrice = Number(option && option.price || 0);

    if (!option || !Array.isArray(option.optionData) || !option.optionData.length) {
      return ownPrice;
    }

    var childLowest = null;

    option.optionData.forEach(function (group) {
      var childOptions = getOptions(group);
      if (!childOptions.length) return;

      var groupMin = null;

      childOptions.forEach(function (childOption) {
        var total = getDeepLowestPrice(childOption);

        if (groupMin === null || total < groupMin) {
          groupMin = total;
        }
      });

      if (groupMin !== null) {
        if (childLowest === null || groupMin < childLowest) {
          childLowest = groupMin;
        }
      }
    });

    return ownPrice + (childLowest !== null ? childLowest : 0);
  }

  function getLowestPriceOptionValue(options) {
    if (!Array.isArray(options) || !options.length) return '';

    var lowest = options[0];
    var lowestTotal = getDeepLowestPrice(lowest);

    options.forEach(function (item) {
      var total = getDeepLowestPrice(item);

      if (total < lowestTotal) {
        lowest = item;
        lowestTotal = total;
      }
    });

    return getOptionLabel(lowest);
  }

  function getWeightGroup(data) {
    return (
      getByOptionName(data && data.variant_data, 'Gemstone Weight') ||
      getByOptionName(data && data.variant_data, 'Diamond Weight')
    );
  }

  function getWeightPropertyName(data) {
    var weightGroup = getWeightGroup(data);
    var name = String(weightGroup && weightGroup.option_name || '').trim();

    if (name === 'Gemstone Weight') return 'Gemstone Weight';
    return 'Diamond Weight';
  }

  function getWeightInputName(data, productId) {
    var weightPropertyName = getWeightPropertyName(data);

    if (weightPropertyName === 'Gemstone Weight') {
      return 'nested_gemstone_weight_' + productId;
    }

    return 'nested_diamond_weight_' + productId;
  }

  function getThemeWeightValue() {
    return getSelectedThemeWeightValue();
  }

  function getColorGroupFromWeight(weightObj) {
    return (
      getByOptionName(weightObj && weightObj.optionData, 'Gemstone Type') ||
      getByOptionName(weightObj && weightObj.optionData, 'Diamond Color')
    );
  }

  function getColorPropertyName(weightObj) {
    var group = getColorGroupFromWeight(weightObj);
    var name = String(group && group.option_name || '').trim();

    if (name === 'Gemstone Type') return 'Gemstone Type';
    return 'Diamond Color';
  }

  function getColorInputName(data, productId) {
    var weightObj = getSelectedWeightObject(data, productId);
    var colorPropertyName = getColorPropertyName(weightObj);

    if (colorPropertyName === 'Gemstone Type') {
      return 'nested_gemstone_type_' + productId;
    }

    return 'nested_diamond_color_' + productId;
  }

  function getSelectedWeightObject(data, productId) {
    var weightGroup = getWeightGroup(data);
    var options = getOptions(weightGroup);
    var selectedWeight =
      getSelectedRadioValue(getWeightInputName(data, productId)) ||
      getThemeWeightValue();

    if (!options.length) return null;

    var matched = options.find(function (item) {
      return getOptionLabel(item) === selectedWeight;
    });

    return matched || options[0];
  }

  function getSelectedColorObject(data, productId) {
    var weightObj = getSelectedWeightObject(data, productId);
    var colorGroup = getColorGroupFromWeight(weightObj);
    var colorOptions = getOptions(colorGroup);
    var selectedColor =
      getSelectedRadioValue(getColorInputName(data, productId)) ||
      getSelectedThemeGemstoneTypeValue();

    if (!colorOptions.length) return null;

    return colorOptions.find(function (item) {
      return getOptionLabel(item) === selectedColor;
    }) || colorOptions[0];
  }

  function getGroupFromWeight(weightObj, name) {
    return getByOptionName(weightObj && weightObj.optionData, name);
  }

  function toggleFieldset(wrapSelector, show) {
    var wrap = document.querySelector(wrapSelector);
    if (!wrap) return;

    var fieldset = wrap.closest('[data-nested-option-fieldset]');

    if (fieldset) {
      fieldset.style.display = show ? '' : 'none';
    }
  }

  function renderOptions(wrapSelector, inputName, idPrefix, optionName, options, selectedValue) {
    var wrap = document.querySelector(wrapSelector);
    if (!wrap) return;

    wrap.innerHTML = '';

    if (!Array.isArray(options) || !options.length) return;

    options.forEach(function (option, index) {
      var label = getOptionLabel(option);
      var price = Number(option.price || 0);
      var comparePrice = Number(option.compare_at_price || 0);
      var checked = String(label).trim() === String(selectedValue || '').trim();

      wrap.insertAdjacentHTML('beforeend', `
        <div class="product-variant-input-radio nested-v1-option-item">
          <input
            class="nested-v1-option-radio"
            type="radio"
            id="${idPrefix}-${index}"
            name="${inputName}"
            value="${label.replace(/"/g, '&quot;')}"
            data-option-name="${optionName}"
            data-option-label="${label.replace(/"/g, '&quot;')}"
            data-price="${price}"
            data-compare-price="${comparePrice}"
            data-percentage="${Number(option.percentage || 0)}"
            ${checked ? 'checked' : ''}
          >
          <label class="product-form__label nested-v1-option-label" for="${idPrefix}-${index}">
            <span class="text">${label}</span>
          </label>
        </div>
      `);
    });
  }

  function ensureGoldPurityWrapper() {
    var existingWrap = document.querySelector('[data-gold-purity-wrap]');

    var weightFieldset =
      document.querySelector('input[data-option-name="Gemstone Weight"]')?.closest('fieldset') ||
      document.querySelector('input[name="Gemstone Weight"]')?.closest('fieldset') ||
      document.querySelector('input[data-option-name="Diamond Weight"]')?.closest('fieldset') ||
      document.querySelector('input[name="Diamond Weight"]')?.closest('fieldset');

    if (!weightFieldset) return existingWrap || null;

    if (existingWrap) {
      var existingFieldset = existingWrap.closest('[data-nested-option-fieldset], fieldset, .product-form__input');

      if (existingFieldset && existingFieldset.previousElementSibling !== weightFieldset) {
        weightFieldset.insertAdjacentElement('afterend', existingFieldset);
      }

      return existingWrap;
    }

    var fieldset = document.createElement('fieldset');
    fieldset.className = 'product-form__input product-form__input--pill nested-v1-option-fieldset Gold_Purity';
    fieldset.setAttribute('data-nested-option-fieldset', '');
    fieldset.setAttribute('data-option-index', '999');
    fieldset.setAttribute('data-product-attribute', 'set-rectangle');

    fieldset.innerHTML = `
      <legend class="form__label">
        Gold Purity:
      </legend>
      <div class="nested-v1-option-wrap" data-gold-purity-wrap></div>
    `;

    weightFieldset.insertAdjacentElement('afterend', fieldset);

    return fieldset.querySelector('[data-gold-purity-wrap]');
  }

  function renderColorOptions(data, productId, preferredColor) {
    var weightObj = getSelectedWeightObject(data, productId);
    var colorGroup = getColorGroupFromWeight(weightObj);
    var colorOptions = getOptions(colorGroup);
    var colorPropertyName = getColorPropertyName(weightObj);
    var colorInputName = getColorInputName(data, productId);

    var colorWrap =
      document.querySelector('[data-gemstone-type-wrap]') ||
      document.querySelector('[data-diamond-color-wrap]');

    var wrapSelector = colorWrap && colorWrap.hasAttribute('data-gemstone-type-wrap')
      ? '[data-gemstone-type-wrap]'
      : '[data-diamond-color-wrap]';

    if (!colorOptions.length || !colorWrap) {
      if (colorWrap) colorWrap.innerHTML = '';

      toggleFieldset(wrapSelector, false);

      setNestedProperty('Diamond Color', '');
      setNestedProperty('Gemstone Type', '');
      setNestedPriceProperty('Diamond Color', 0);
      setNestedComparePriceProperty('Diamond Color', 0);
      setNestedPriceProperty('Gemstone Type', 0);
      setNestedComparePriceProperty('Gemstone Type', 0);

      return;
    }

    toggleFieldset(wrapSelector, true);

    var selectedColor =
      preferredColor ||
      getSelectedThemeGemstoneTypeValue() ||
      '';

    var exists = colorOptions.some(function (item) {
      return getOptionLabel(item) === selectedColor;
    });

    if (!exists) {
      selectedColor = getLowestPriceOptionValue(colorOptions);
    }

    renderOptions(
      wrapSelector,
      colorInputName,
      colorPropertyName === 'Gemstone Type'
        ? 'nested-gemstone-type-' + productId
        : 'nested-diamond-color-' + productId,
      colorPropertyName,
      colorOptions,
      selectedColor
    );
  }

  function renderClarityOptions(data, productId, preferredClarity) {
    var colorObj = getSelectedColorObject(data, productId);
    var clarityGroup = getByOptionName(colorObj && colorObj.optionData, 'Diamond Clarity');
    var clarityOptions = getOptions(clarityGroup);

    if (!clarityOptions.length) {
      var emptyWrap = document.querySelector('[data-diamond-clarity-wrap]');
      if (emptyWrap) emptyWrap.innerHTML = '';

      toggleFieldset('[data-diamond-clarity-wrap]', false);
      setNestedProperty('Diamond Clarity', '');
      setNestedPriceProperty('Diamond Clarity', 0);
      setNestedComparePriceProperty('Diamond Clarity', 0);

      return;
    }

    toggleFieldset('[data-diamond-clarity-wrap]', true);

    var selectedClarity = preferredClarity || '';
    var exists = clarityOptions.some(function (item) {
      return getOptionLabel(item) === selectedClarity;
    });

    if (!exists) {
      selectedClarity = getLowestPriceOptionValue(clarityOptions);
    }

    renderOptions(
      '[data-diamond-clarity-wrap]',
      'nested_diamond_clarity_' + productId,
      'nested-diamond-clarity-' + productId,
      'Diamond Clarity',
      clarityOptions,
      selectedClarity
    );
  }

  function renderGoldPurityOptions(data, productId, preferredPurity) {
    var weightObj = getSelectedWeightObject(data, productId);
    var goldGroup = getGroupFromWeight(weightObj, 'Gold Purity') || getByOptionName(data && data.variant_data, 'Gold Purity');
    var goldOptions = getOptions(goldGroup);
    var wrap = ensureGoldPurityWrapper();

    if (!wrap) return;

    if (!goldOptions.length) {
      wrap.innerHTML = '';
      toggleFieldset('[data-gold-purity-wrap]', false);
      setNestedProperty('Gold Purity', '');
      setNestedPriceProperty('Gold Purity', 0);
      setNestedComparePriceProperty('Gold Purity', 0);

      return;
    }

    toggleFieldset('[data-gold-purity-wrap]', true);

    var oldSelected = document.querySelector('input[name^="nested_gold_purity_"]:checked');
    var selectedPurity = preferredPurity || '';

    if (!selectedPurity && oldSelected) {
      selectedPurity = oldSelected.value || oldSelected.getAttribute('data-option-label') || '';
    }

    var exists = goldOptions.some(function (item) {
      return getOptionLabel(item) === selectedPurity;
    });

    if (!exists) {
      selectedPurity = getLowestPriceOptionValue(goldOptions);
    }

    renderOptions(
      '[data-gold-purity-wrap]',
      'nested_gold_purity_' + productId,
      'nested-gold-purity-' + productId,
      'Gold Purity',
      goldOptions,
      selectedPurity
    );
  }

  function syncNestedProperties(productId) {
    var data = parseNestedVariantData();
    if (!data) return;

    var weightPropertyName = getWeightPropertyName(data);
    var weightInputName = getWeightInputName(data, productId);

    var weightEl =
      document.querySelector('input[name="' + weightInputName + '"]:checked') ||
      document.querySelector('input[data-option-name="' + weightPropertyName + '"]:checked') ||
      document.querySelector('input[name="' + weightPropertyName + '"]:checked');

    var colorInputName = getColorInputName(data, productId);
    var selectedWeightObj = getSelectedWeightObject(data, productId);
    var colorPropertyName = getColorPropertyName(selectedWeightObj);

    var colorEl =
      document.querySelector('input[name="' + colorInputName + '"]:checked') ||
      document.querySelector('input[data-option-name="' + colorPropertyName + '"]:checked') ||
      document.querySelector('input[name="' + colorPropertyName + '"]:checked');

    var clarityEl = document.querySelector('input[name="nested_diamond_clarity_' + productId + '"]:checked');
    var goldEl = document.querySelector('input[name="nested_gold_purity_' + productId + '"]:checked');

    ensureNestedPropertyInput(weightPropertyName);
    ensureNestedPriceInput(weightPropertyName);
    ensureNestedComparePriceInput(weightPropertyName);

    ensureNestedPropertyInput('Gold Purity');
    ensureNestedPriceInput('Gold Purity');
    ensureNestedComparePriceInput('Gold Purity');

    setNestedProperty('Diamond Weight', '');
    setNestedPriceProperty('Diamond Weight', 0);
    setNestedComparePriceProperty('Diamond Weight', 0);
    setNestedProperty('Gemstone Weight', '');
    setNestedPriceProperty('Gemstone Weight', 0);
    setNestedComparePriceProperty('Gemstone Weight', 0);

    if (weightEl) {
      setNestedProperty(weightPropertyName, weightEl.getAttribute('data-option-label') || weightEl.value || '');
      setNestedPriceProperty(weightPropertyName, (Number(weightEl.getAttribute('data-price')) || 0) * 100);
      setNestedComparePriceProperty(weightPropertyName, (Number(weightEl.getAttribute('data-compare-price')) || 0) * 100);
    }

    setNestedProperty('Diamond Color', '');
    setNestedPriceProperty('Diamond Color', 0);
    setNestedComparePriceProperty('Diamond Color', 0);
    setNestedProperty('Gemstone Type', '');
    setNestedPriceProperty('Gemstone Type', 0);
    setNestedComparePriceProperty('Gemstone Type', 0);

    if (colorEl) { 
      ensureNestedPropertyInput(colorPropertyName);
      ensureNestedPriceInput(colorPropertyName);
      ensureNestedComparePriceInput(colorPropertyName);
      setNestedProperty(colorPropertyName, colorEl.getAttribute('data-option-label') || colorEl.value || '');
      setNestedPriceProperty(colorPropertyName, (Number(colorEl.getAttribute('data-price')) || 0) * 100);
      setNestedComparePriceProperty(colorPropertyName, (Number(colorEl.getAttribute('data-compare-price')) || 0) * 100);
    }

    if (clarityEl) {
      setNestedProperty('Diamond Clarity', clarityEl.getAttribute('data-option-label') || '');
      setNestedPriceProperty('Diamond Clarity', (Number(clarityEl.getAttribute('data-price')) || 0) * 100);
      setNestedComparePriceProperty('Diamond Clarity', (Number(clarityEl.getAttribute('data-compare-price')) || 0) * 100);
    } else {
      setNestedProperty('Diamond Clarity', '');
      setNestedPriceProperty('Diamond Clarity', 0);
      setNestedComparePriceProperty('Diamond Clarity', 0);
    }

    if (goldEl) {
      setNestedProperty('Gold Purity', goldEl.getAttribute('data-option-label') || goldEl.value || '');
      setNestedPriceProperty('Gold Purity', (Number(goldEl.getAttribute('data-price')) || 0) * 100);
      setNestedComparePriceProperty('Gold Purity', (Number(goldEl.getAttribute('data-compare-price')) || 0) * 100);
    } else {
      setNestedProperty('Gold Purity', '');
      setNestedPriceProperty('Gold Purity', 0);
      setNestedComparePriceProperty('Gold Purity', 0);
    }
  }

  function getPreferredDefaultWeight(data, productId) {
    var inputName = getWeightInputName(data, productId);
    var inputs = Array.from(document.querySelectorAll('input[name="' + inputName + '"]'));

    if (!inputs.length) {
      inputs = Array.from(document.querySelectorAll(
        'input[data-option-name="Gemstone Weight"], input[name="Gemstone Weight"], input[data-option-name="Diamond Weight"], input[name="Diamond Weight"]'
      ));
    }

    if (!inputs.length) return null;

    var checked = inputs.find(function (input) {
      return input.checked;
    });

    if (checked) return checked;

    var lowest = inputs[0];

    inputs.forEach(function (input) {
      if (Number(input.getAttribute('data-price') || 0) < Number(lowest.getAttribute('data-price') || 0)) {
        lowest = input;
      }
    });

    return lowest;
  }

  function initNestedOptions(forceFresh) {
    var wrapper = document.querySelector('[data-nested-v1-wrapper]');
    var productId = wrapper?.getAttribute('data-product-id') || getShopifyProductId() || 'product';

    var data = parseNestedVariantData();
    if (!data) return;

    var weightInputName = getWeightInputName(data, productId);

    if (forceFresh) {
      document.querySelectorAll('input[name="' + weightInputName + '"]').forEach(function (el) {
        el.checked = false;
        el.removeAttribute('checked');
        el.defaultChecked = false;
      });

      document.querySelectorAll('input[name="nested_diamond_weight_' + productId + '"]').forEach(function (el) {
        el.checked = false;
        el.removeAttribute('checked');
        el.defaultChecked = false;
      });

      document.querySelectorAll('input[name="nested_gemstone_weight_' + productId + '"]').forEach(function (el) {
        el.checked = false;
        el.removeAttribute('checked');
        el.defaultChecked = false;
      });

      document.querySelectorAll('input[name="nested_diamond_color_' + productId + '"]').forEach(function (el) {
        el.checked = false;
        el.removeAttribute('checked');
        el.defaultChecked = false;
      });

      document.querySelectorAll('input[name="nested_gemstone_type_' + productId + '"]').forEach(function (el) {
        el.checked = false;
        el.removeAttribute('checked');
        el.defaultChecked = false;
      });

      document.querySelectorAll('input[name="nested_diamond_clarity_' + productId + '"]').forEach(function (el) {
        el.checked = false;
        el.removeAttribute('checked');
        el.defaultChecked = false;
      });

      document.querySelectorAll('input[name="nested_gold_purity_' + productId + '"]').forEach(function (el) {
        el.checked = false;
        el.removeAttribute('checked');
        el.defaultChecked = false;
      });
    }

    var defaultWeightEl = getPreferredDefaultWeight(data, productId);

    if (defaultWeightEl && defaultWeightEl.name && defaultWeightEl.name.indexOf('nested_') === 0) {
      document.querySelectorAll('input[name="' + weightInputName + '"]').forEach(function (el) {
        el.checked = false;
        el.removeAttribute('checked');
        el.defaultChecked = false;
      });

      defaultWeightEl.checked = true;
      defaultWeightEl.setAttribute('checked', 'checked');
      defaultWeightEl.defaultChecked = true;
    }

    renderColorOptions(data, productId, '');
    renderClarityOptions(data, productId, '');
    renderGoldPurityOptions(data, productId, '');
    syncNestedProperties(productId);

    document.dispatchEvent(new Event('updateMainPrice'));
  }

  function renderGoldPurityFromMetafield() {
    var wrapper = document.querySelector('[data-nested-v1-wrapper]');
    var productId = wrapper?.getAttribute('data-product-id') || getShopifyProductId() || 'product';

    var data = parseNestedVariantData();
    if (!data) return;

    renderGoldPurityOptions(data, productId, '');
    syncNestedProperties(productId);

    document.dispatchEvent(new Event('updateMainPrice'));
  }

  window.initNestedOptions = initNestedOptions;
  window.renderGoldPurityFromMetafield = renderGoldPurityFromMetafield;

  document.addEventListener('force:nested:init', function () {
    initNestedOptions(true);
  });

  document.addEventListener('change', function (e) {
    var wrapper = document.querySelector('[data-nested-v1-wrapper]');
    var productId = wrapper?.getAttribute('data-product-id') || getShopifyProductId() || 'product';

    var data = parseNestedVariantData();
    if (!data) return;

    var weightInputName = getWeightInputName(data, productId);
    var colorInputName = getColorInputName(data, productId);

    if (
      e.target.matches('input[name="' + weightInputName + '"]') ||
      e.target.matches('input[data-option-name="Gemstone Weight"]') ||
      e.target.matches('input[name="Gemstone Weight"]') ||
      e.target.matches('input[data-option-name="Diamond Weight"]') ||
      e.target.matches('input[name="Diamond Weight"]')
    ) {
      var currentColor = getSelectedRadioValue(colorInputName) || getSelectedThemeGemstoneTypeValue();
      var currentClarity = getSelectedRadioValue('nested_diamond_clarity_' + productId);
      var currentPurity = getSelectedRadioValue('nested_gold_purity_' + productId);

      renderColorOptions(data, productId, currentColor);
      renderClarityOptions(data, productId, currentClarity);
      renderGoldPurityOptions(data, productId, currentPurity);
      syncNestedProperties(productId);

      document.dispatchEvent(new Event('updateMainPrice'));
    }

    if (
      e.target.matches('input[name="' + colorInputName + '"]') ||
      e.target.matches('input[data-option-name="Gemstone Type"]') ||
      e.target.matches('input[name="Gemstone Type"]') ||
      e.target.matches('input[data-option-name="Diamond Color"]') ||
      e.target.matches('input[name="Diamond Color"]')
    ) {
      var currentClarityOnly = getSelectedRadioValue('nested_diamond_clarity_' + productId);

      renderClarityOptions(data, productId, currentClarityOnly);
      syncNestedProperties(productId);

      document.dispatchEvent(new Event('updateMainPrice'));
    }

    if (
      e.target.matches('input[name="nested_diamond_clarity_' + productId + '"]') ||
      e.target.matches('input[name="nested_gold_purity_' + productId + '"]')
    ) {
      syncNestedProperties(productId);
      document.dispatchEvent(new Event('updateMainPrice'));
    }
  });

  function startNestedInit() {
    initNestedOptions(true);
    renderGoldPurityFromMetafield();

    setTimeout(function () {
      renderGoldPurityFromMetafield();
    }, 300);

    setTimeout(function () {
      renderGoldPurityFromMetafield();
    }, 800);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startNestedInit, { once: true });
  } else {
    startNestedInit();
  }

  window.addEventListener('pageshow', function () {
    startNestedInit();
  });
})();
